{
  "country_code": "49",
  "toMiles": false,
  "neighborhoods": true,
  "currency_config_up": "EUR",
  "masks": {
    "phone": "0000 0000000",
    "cell": "0000 0000000",
    "secret_number": "00000000000",
    "secret_number_company": "DE000000000",
    "ssn_mask": "00000000000",
    "zipcode": "00000",
    "date_mask": "dd.MM.yyyy",
    "date_mask_format_m": "dd.MM.yyyy",
    "date_mask_two": "dd.MM",
    "mi": "KM",
    "states": [
      "BW",
      "BY",
      "BE",
      "BB",
      "HB",
      "HH",
      "HE",
      "MV",
      "NI",
      "NW",
      "RP",
      "SL",
      "SN",
      "ST",
      "SH",
      "TH"
    ]
  },
  "sort_by": "Sortieren nach",
  "sale_without_registration": "Verkauf ohne Registrierung",
  "i_dont_need_indentify_client": "Ich muss den Kunden nicht identifizieren",
  "closing": "Abschluss",
  "uf": "Bundesländer",
  "contact": "Kontakt",
  "favorite_card_comment": "z.B.: Meine Lieblingskarte",
  "finalize_order_comment": "Bestellung abschließen",
  "goodbye": "Auf Wiedersehen!",
  "opened": "geöffnet",
  "no_categories_available_at_moment": "Derzeit sind keine Kategorien für Tischbestellungen verfügbar.",
  "check_admin_panel_categories_active": "Überprüfen Sie im Admin-Panel, ob die Kategorien aktiv und für Tischbestellungen verfügbar sind.",
  "cart_empty": "Warenkorb leer",
  "optional": "optional",
  "add_comment": "+Hinzufügen",
  "are_you_here": "sind Sie hier?",
  "your_location": "Ihr Standort. Ziehen Sie die Markierung, um anzupassen.",
  "adjust_location": "Standort anpassen",
  "obs": "Bemerkungen",
  "confirm_send_to_whatsapp": "Möchten Sie die Bestellung per WhatsApp senden?",
  "send_message": "Nachricht senden",
  "dont_send_message": "Nachricht nicht senden",
  "my_orders": "Meine Bestellungen",
  "tax_and_time_of_shipping": "Versandkosten und Lieferzeit",
  "scheduling": "Vorbestellungen",
  "scheduling2": "Terminierung",
  "package_s": "Pakete",
  "close_order": "Bestellung abschließen",
  "verify": "überprüfen",
  "add_more_items": "weitere Artikel hinzufügen",
  "next": "Weiter",
  "edit_item": "Artikel bearbeiten",
  "possibles": "möglich",
  "select_shipoing": "Versand auswählen",
  "take_out": "Abholung",
  "cupom": "Gutschein",
  "active_your_cupom": "Gutschein aktivieren",
  "code_of_cupom": "Gutscheincode",
  "total": "Gesamt",
  "select_the_form_of_shipping": "Versandart auswählen",
  "mandatory": "Pflichtfeld",
  "go_to_payment": "Zur Zahlung",
  "pay_on_app": "In der App bezahlen",
  "pay_on_shippingg": "Bei Lieferung bezahlen",
  "my_cards": "Meine Karten",
  "discont": "Rabatt",
  "payment_in_comment": "Zahlung mit",
  "i_need_transhipment": "Wechselgeld für",
  "i_not_need_transhipment": "Kein Wechselgeld benötigt",
  "secret_number_on_note": "Steuer-ID auf Rechnung",
  "search_products_by_name_or_description": "Produkte nach Name oder Beschreibung suchen",
  "outside_the_coverage_area": "außerhalb des Liefergebiets",
  "unavilable": "Nicht verfügbar",
  "avaible": "verfügbar",
  "product_unavilable": "Produkt nicht verfügbar",
  "unavilable_amount": "Menge nicht verfügbar",
  "table_s": "Tische",
  "discont_of": "Rabatt von",
  "free_freight": "Kostenloser Versand",
  "free_freight_comment": "Kostenloser Versand",
  "free_comment_up": "KOSTENLOS",
  "covered_address": "Lieferadresse abgedeckt",
  "send_order": "Bestellung senden",
  "you_are_blocked": "Sie sind gesperrt",
  "enter_your_cell": "Geben Sie Ihre Handynummer ein",
  "enter_your_email": "Geben Sie Ihre E-Mail ein",
  "enter_your_address": "Geben Sie Ihre Adresse ein",
  "enter_you_ddd": "Geben Sie Ihre Handynummer mit Vorwahl ein",
  "minimum_unconceived_value": "Mindestbestellwert nicht erreicht",
  "finish_payment_pix": "Zahlung per Pix abschließen",
  "finish_payment": "Zahlung abschließen",
  "payment_online": "Online-Zahlung",
  "payment_offline": "Offline-Zahlung",
  "add_new_card": "Neue Karte hinzufügen",
  "pay_on_delivery": "Bei Lieferung bezahlen",
  "i_need_change_for": "Ich brauche Wechselgeld für",
  "i_dont_need_change": "Ich brauche kein Wechselgeld",
  "send_the_receipt": "Senden Sie den Beleg an unser WhatsApp, um Ihren Service zu beschleunigen",
  "copy_key": "Schlüssel kopieren",
  "select_the_flag": "Flagge auswählen",
  "select_the_flag_comment": "Flagge auswählen",
  "cpf_on_the_receipt": "Steuer-ID auf dem Beleg",
  "cpf_cnpj_invalid": "Ungültige Steuer-ID",
  "how_to_pay_with_pix": "So bezahlen Sie mit PIX",
  "enter_cpf_generate_pix": "Geben Sie Ihre Steuer-ID ein, um einen PIX-Schlüssel zu generieren",
  "enter_cpf": "Geben Sie Ihre Steuer-ID ein",
  "enter_a_valid_cpf": "Geben Sie eine gültige Steuer-ID ein",
  "order_pending_payment": "Bestellung mit ausstehender Zahlung",
  "generate_pix_key": "PIX-Schlüssel generieren",
  "pix_copy_paste": "PIX kopieren und einfügen",
  "copy_code": "Code kopieren",
  "pix_key_expired": "Ihr PIX-Schlüssel ist abgelaufen. Klicken Sie auf die Schaltfläche, um einen neuen Code zu generieren",
  "paste_this_code_your_bank": "Fügen Sie diesen Code in die Option PIX kopieren und einfügen Ihrer Bank ein",
  "verify_pix_payment": "PIX-Zahlung überprüfen",
  "card_details": "Kartendetails",
  "name_on_the_card": "Name auf der Karte",
  "card_number": "Kartennummer",
  "expiry": "Ablaufdatum",
  "card_nickname": "Kartenspitzname (optional)",
  "billing_adress": "Rechnungsadresse",
  "zip_code_not_found": "PLZ nicht gefunden",
  "adress_line_2": "Adresszeile 2 (optional)",
  "order_will_be_delivered": "Bestellung wird geliefert an",
  "to_consult": "nachfragen",
  "flavors_comment": "Geschmacksrichtungen",
  "flavor_comment": "Geschmacksrichtung",
  "crust": "Rand",
  "general_toppings": "Allgemeine Beläge",
  "single_crust": "Einfacher Rand",
  "message_cvv_payment": "Geben Sie den CVV-Code Ihrer Karte ein, um die Zahlung abzuschließen",
  "code_back_of_your_card": "Dieser Code befindet sich auf der Rückseite Ihrer Karte",
  "complete_payment": "Zahlung abschließen",
  "what_card_nickname": "Wie ist der Spitzname dieser Karte?",
  "what_your_name": "Wie ist Ihr Name?",
  "open_new_order": "Neue Bestellung öffnen",
  "enter_name_your_order": "Geben Sie einen Namen für Ihre Bestellung ein",
  "select_order": "Bestellung auswählen",
  "addition": "Zusatz",
  "use_cashback": "Cashback-Guthaben verwenden",
  "balance": "Guthaben",
  "indentify_yourself": "Identifizieren Sie sich",
  "whatsapp_number": "WhatsApp-Nummer",
  "date_of_birth": "Geburtsdatum",
  "place_order_necessary_information": "Um die Bestellung aufzugeben, müssen die obigen Informationen ausgefüllt werden",
  "order_slip_s": "Bestellzettel",
  "no_active_orders": "Keine aktiven Bestellungen",
  "order_sucess": "Bestellung erfolgreich aufgegeben",
  "send_confirmation_whatsapp": "Bestätigung per WhatsApp senden",
  "select_delivery_date": "Lieferdatum auswählen",
  "time_zone_is_different": "Wir haben festgestellt, dass Ihre Zeitzone von der des Geschäfts abweicht. Ihre entsprechende Empfangszeit wird neben der Uhrzeit angezeigt",
  "delivery_time_between": "Wählen Sie eine Lieferzeit zwischen den Zeiträumen",
  "delivery_for_order": "Wählen Sie eine Lieferung für Ihre Bestellung",
  "establishment_notes": "Hinweise des Geschäfts",
  "no_more_avaible_slots_for_orders": "Wir haben keine verfügbaren Zeitfenster mehr für Bestellungen. Bitte kontaktieren Sie unser Geschäft",
  "contact_establishment": "Kontaktieren Sie das Geschäft",
  "no_slots_avaible_for_orders_on_that_day": "Wir haben keine verfügbaren Zeitfenster mehr für Bestellungen an diesem Tag",
  "please_select_another_date": "Bitte wählen Sie ein anderes Datum.",
  "continue": "Weiter",
  "last_orders": "Letzte Bestellungen",
  "view_order": "Bestellung ansehen",
  "edit_addresses": "Adressen bearbeiten",
  "addresses": "Adressen",
  "add_new_addresses": "Neue Adressen hinzufügen",
  "create_address_or_use_list_below": "Erstellen Sie eine neue Adresse oder verwenden Sie die Liste unten",
  "more_information": "Weitere Informationen",
  "notification_permissions": "Um Benachrichtigungen zu erhalten, müssen Sie die Benachrichtigungsberechtigungen auf Ihrem Gerät erteilen.",
  "opening_hours": "Öffnungszeiten",
  "from_de": "Von",
  "to": "bis",
  "pay_online": "Online bezahlen",
  "choose_this_option_secure_payment": "Wählen Sie diese Option für eine sichere Zahlung über unser Online-System.",
  "choose_option_receiving": "Möchten Sie lieber bei Erhalt Ihrer Bestellung bezahlen? Wählen Sie diese Option.",
  "acess_your_payment_app": "Öffnen Sie Ihre Zahlungs-App",
  "qrcode_copy_paste_payment": "Scannen Sie den QR-Code oder kopieren und fügen Sie den Zahlungscode ein",
  "pay_credited_instantly": "Bezahlen Sie und es wird sofort gutgeschrieben",
  "enter_your_cpf": "Geben Sie Ihre Steuer-ID ein",
  "local_pickup": "Abholung vor Ort",
  "payment_still_pending": "Zahlung noch ausstehend. Bitte versuchen Sie es erneut.",
  "confirmation_is_taking_too_long": "Wenn die Bestätigung zu lange dauert, klicken Sie auf die Schaltfläche, um fortzufahren.",
  "use_delivery_address": "Lieferadresse verwenden",
  "state": "Bundesland",
  "cash_payment": "Barzahlung",
  "payment_meal_voucher": "Zahlung mit Essensmarken",
  "payment_food_voucher": "Zahlung mit Lebensmittelgutscheinen",
  "receipt_to_our_whatsapp": "Senden Sie den Beleg an unser WhatsApp, um Ihren Service zu beschleunigen",
  "total_to_transfer": "Zu überweisender Betrag",
  "type_of_key": "Schlüsseltyp",
  "save_future_purchases": "Für zukünftige Käufe speichern",
  "finalize_order": "Bestellung abschließen",
  "add_on": "Zusatz",
  "error_generating_qrcode": "Fehler beim Generieren des QR-Codes. Bitte versuchen Sie es erneut.",
  "payment_not_detected_check_banking": "Zahlung nicht erkannt. Bitte überprüfen Sie Ihre Banking-App.",
  "error_processing_payment": "Fehler bei der Zahlungsverarbeitung, bitte versuchen Sie es erneut.",
  "error_creating_customer": "Fehler beim Erstellen des Kunden. Bitte versuchen Sie es erneut.",
  "choose_single_crust": "Wählen Sie den einfachen Rand",
  "choose_single_crust_comment": "Einfachen Rand wählen",
  "choose_crust_comment": "Rand wählen",
  "crust_without_filling": "Rand ohne Füllung",
  "choose_the": "wählen Sie",
  "choose_the_o": "wählen Sie",
  "complete_order_mandotory": "Vervollständigen Sie Ihre Bestellung mit den Pflichtartikeln",
  "no_orders_moment": "Derzeit keine Bestellungen",
  "fee_comment": "Gebühr",
  "pickup_only": "Nur Abholung",
  "loading_dates": "Daten werden geladen",
  "choose_date": "Wählen Sie ein Datum",
  "see_full_list": "Klicken Sie hier, um die vollständige Produktliste zu sehen",
  "no_products_found": "Entschuldigung, keine Produkte gefunden",
  "size_unavilable": "Größe nicht verfügbar",
  "edit_notes": "Notizen bearbeiten",
  "remove_item": "Artikel entfernen",
  "point_camera_qrcode": "Richten Sie bitte Ihre Kamera auf den QR-Code am Tisch, an dem Sie bestellen möchten",
  "order_status": "Bestellstatus",
  "in_preparation": "In Zubereitung",
  "canceled": "Storniert",
  "order_received": "Bestellung erhalten",
  "pending_payment": "Zahlung ausstehend",
  "order_approved": "Bestellung genehmigt",
  "order_preparation": "Bestellung in Zubereitung",
  "order_canceled": "Bestellung storniert",
  "order_out_for_delivery": "Bestellung ist unterwegs",
  "order_ready_for_pickup": "Bestellung abholbereit",
  "send_order_whatsapp": "Bestellung per WhatsApp senden",
  "reference_point": "Referenzpunkt",
  "house_corner": "Hausecke",
  "address_complement": "Adresszusatz",
  "block_apt": "Block, Wohnung",
  "ave": "Musterstraße 123",
  "date_usa": "TT.MM.JJJJ",
  "choose_time": "Wählen Sie eine Uhrzeit",
  "minimum_quantity": "Mindestmenge",
  "maximum_quantity": "Höchstmenge",
  "repeat_order": "Bestellung wiederholen",
  "pick_up_counter": "Abholung an der Theke",
  "counter_and_delivery": "Theke/Lieferung",
  "discount_comment": "Rabatt",
  "discount_of": "Rabatt von",
  "applied": "angewendet",
  "change_address": "Adresse ändern",
  "message_no_costumer_selected": "Kein Kunde für diese Bestellung ausgewählt. Bitte suchen Sie einen registrierten Kunden oder registrieren Sie einen neuen, um fortzufahren.",
  "search_customer": "Kunde suchen",
  "add_customer": "Kunde hinzufügen",
  "outside_service_area": "AUSSERHALB DES LIEFERGEBIETS",
  "free_comment": "Kostenlos",
  "activate_coupon_comment": "Gutschein aktivieren",
  "order_type": "Bestellart",
  "place_order": "Bestellung aufgeben",
  "open_register": "Kasse öffnen",
  "initial_balance": "Anfangssaldo €",
  "initial_balance_n": "Anfangssaldo",
  "income": "Einnahmen",
  "cash_register_status": "Kassenstatus",
  "cash_outflow": "Bargeldabfluss",
  "close_cash_register": "Kasse schließen",
  "cash_balance": "Barguthaben",
  "cashier_balance": "Kassenstand",
  "final_balance": "Endsaldo",
  "new_order": "Neue Bestellung",
  "create_order_slip": "Bestellzettel erstellen",
  "change_tables": "Tische wechseln",
  "table_change": "Tischwechsel",
  "print_table": "Tisch drucken",
  "close_table": "Tisch schließen",
  "client_comment": "Kunde",
  "no_registred_address": "Keine registrierte Adresse",
  "none": "keine",
  "search_name_comment": "Nach Code oder Name suchen",
  "search_flavor_comment": "Nach Code oder Geschmack suchen",
  "waiting_service": "Wartet auf Bedienung",
  "pause_comment": "Pausieren",
  "unpause_comment": "Fortsetzen",
  "order_buy": "Bestellung",
  "order_the_table": "Am Tisch bestellen",
  "registration_comment": "Registrierung",
  "change_comment": "Wechselgeld",
  "one_more_comment": "Noch eins",
  "customer": "Kunden",
  "customer_name_comment": "Kundenname",
  "customer_last_name_comment": "Kunden Nachname",
  "email_example_comment": "kunde@beispiel.de",
  "ssn_model_comment": "00000000000",
  "number_model_comment": "0000 0000000",
  "order_by": "Sortieren nach",
  "delivery_address": "Lieferadresse",
  "number_comment": "Nummer",
  "no_number": "Keine Nummer",
  "dont_know_my_zip": "Ich kenne meine PLZ nicht",
  "other_s": "Sonstiges",
  "deliver_this_address": "An diese Adresse liefern",
  "out_coverage_area": "Außerhalb des Liefergebiets",
  "finalize_appointment": "Termin abschließen",
  "return_cancel": "Zurück/Abbrechen",
  "return": "Zurück",
  "remaining": "verbleibend",
  "fee_discount": "Gebühr/Rabatt",
  "how_pay_pix": "So bezahlen Sie mit PIX",
  "step": "Schritt",
  "payment_deadline": "Die Zahlungsfrist ist in",
  "select_comment": "Auswählen",
  "call_back_house": "z.B.: Hinterhaus klingeln",
  "change_for_comment": "Wechselgeld für",
  "for": "für",
  "out_for_delivery": "Unterwegs zur Lieferung",
  "waiting_for_pickup": "Wartet auf Abholung",
  "add_flavor": "Geschmacksrichtung hinzufügen",
  "your_flavor": " Ihre Geschmacksrichtung",
  "choose": "Wählen",
  "choose_up_to": "Wählen Sie bis zu",
  "selected_date_is_earlier": "Das ausgewählte Datum liegt vor dem aktuellen Datum",
  "register_closing": "Kassenabschluss",
  "confirm_register_closing": "Kassenabschluss bestätigen",
  "closing_insert_following": "Beim Abschluss folgende Beträge in Ihre Kassenschublade einfügen",
  "register_login": "Kassen-Login",
  "deposit": "Einzahlung",
  "purpose": "Zweck",
  "list": "Liste",
  "make_payment": "Zahlung durchführen",
  "uncancel_order": "Stornierung aufheben",
  "order_amount": "Gesamtbestellbetrag",
  "print_the": "drucken",
  "next_flavor_comment": "Nächste Geschmacksrichtung",
  "choose_flavor_comment": "Geschmacksrichtung wählen",
  "quantity_unavaible": "Menge nicht verfügbar",
  "complete_toppings_comment": "Beläge vervollständigen",
  "out_stock_toppings_comment": "Nicht vorrätige Beläge",
  "in_stock_comment": "Auf Lager",
  "the_flavors_comment": "die Geschmacksrichtungen",
  "the_crust_comment": "den Rand",
  "the_toppings_comment": "die Beläge",
  "mandatory_to_choose": "Es ist Pflicht zu wählen",
  "time_closed_comment": "Zeit abgelaufen!",
  "change_less_purchase_comment": "Wechselgeld niedriger als Kaufbetrag",
  "free_shipping_comment": "KOSTENLOSER VERSAND",
  "consult_comment": "Nachfragen",
  "location_comment": "Standort",
  "paid_online_comment": "Online bezahlt",
  "track_order": "Bestellung verfolgen",
  "street": "Straße",
  "order_comment": "Bestellung",
  "schedule": "Zeitplan",
  "closed_orders": "Abgeschlossene Bestellungen",
  "scheduling_closed": "Terminierung geschlossen",
  "order_name": "Bestellname",
  "no_product_found": "Kein Produkt gefunden",
  "items_found": "Artikel gefunden",
  "mandatory_items": "Pflichtartikel",
  "minimum": "Minimum",
  "advance": "Weiter",
  "loading_page": "Wird geladen...",
  "enter_city": "Stadt eingeben",
  "select_city": "Stadt auswählen",
  "enter_neighborhood": "Stadtteil eingeben",
  "select_neighborhood": "Stadtteil auswählen",
  "enter_street_name": "Straßenname eingeben",
  "coupon_only_used_purchases": "Dieser Gutschein kann nur für Einkäufe ab verwendet werden",
  "discount_coupon_greater_total": "Der Rabatt des Gutscheins ist höher als der Gesamtbetrag!",
  "add_to_order": "Zur Bestellung hinzufügen",
  "data_print": "Druckdatum",
  "generate_fiscal_note": "Rechnung ausstellen",
  "alert": {
    "unable_to_read": "Ihr Standort konnte nicht gelesen werden, bitte überprüfen Sie, ob die Standortdienste nicht blockiert sind.",
    "address_covarage_area": "Ihre Adresse liegt außerhalb unseres Liefergebiets!",
    "register_open_24": "Eine Kasse ist seit mehr als 24 Stunden geöffnet und wird geschlossen.",
    "table_desactived": "Entschuldigung, dieser Tisch ist derzeit deaktiviert",
    "moment_table_not_avaible": "Dieser Tisch ist derzeit nicht für neue Bestellungen verfügbar",
    "table_not_avaible_new_orders": "Dieser Tisch ist derzeit nicht für neue Bestellungen verfügbar.",
    "order_already_been_completed": "Die vorherige Bestellung wurde bereits abgeschlossen. Sind Sie noch im Restaurant oder möchten Sie eine neue Lieferbestellung aufgeben?",
    "at_the_table": "Ich bin am Tisch",
    "deliver_order": "Bestellung liefern",
    "not_belong_this_table": "Diese Bestellung gehört nicht zu diesem Tisch.",
    "store_closed": "GESCHÄFT GESCHLOSSEN!",
    "not_minimum_value": "Ihre Bestellung hat den Mindestbestellwert nicht erreicht von",
    "failed_validate_coupon": "Gutschein konnte nicht validiert werden, bitte überprüfen Sie Ihre Verbindung!",
    "amount_not_include_delivery_fee": "Dieser Gesamtbetrag enthält keine Liefergebühren.",
    "coupon_used_starting_from": "Dieser Gutschein kann nur für Einkäufe ab verwendet werden",
    "closed_delivery": "LIEFERUNG GESCHLOSSEN",
    "unable_create_customer": "Kunde konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
    "selected_date_earlier_choose_later_date": "Das ausgewählte Datum liegt vor dem aktuellen Datum, bitte wählen Sie ein späteres Datum",
    "try_again_moment": "Es ist etwas Unerwartetes passiert, bitte versuchen Sie es gleich noch einmal.",
    "error_generate_qrcode": "QR-Code konnte nicht generiert werden. Bitte versuchen Sie es erneut.",
    "payment_not_detected": "Zahlung nicht erkannt. Bitte überprüfen Sie Ihre Banking-App.",
    "reloaded_page_message": "Die Seite muss neu geladen werden!",
    "name_and_last_name_and_phone_required": "Name, Nachname und Telefonnummer sind erforderlich",
    "enter_your_details": "Geben Sie Ihre Daten ein",
    "enter_your_name": "Geben Sie Ihren Namen ein",
    "enter_your_whatsapp": "Geben Sie Ihre WhatsApp-Nummer ein",
    "enter_your_date_of_birth": "Geben Sie Ihr Geburtsdatum ein",
    "review_change_amount": "Überprüfen Sie den Wechselgeldbetrag!",
    "no_internet_connection": "Keine Internetverbindung",
    "add_another_card": "Weitere Karte hinzufügen",
    "zip_invalid": "PLZ ist ungültig"
  },
  "calendar": {
    "weekdays": [
      "Mo",
      "Di",
      "Mi",
      "Do",
      "Fr",
      "Sa",
      "So"
    ],
    "months": [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ]
  },
  "timezones": [
    {
      "label": "Berlin",
      "value": "Europe/Berlin"
    }
  ],
  "unitSystem": "metric",
  "distanceinkmto": "Entfernung in km bis",
  "distance": "Entfernung",
  "distance_added_successfully": "Entfernung erfolgreich hinzugefügt",
  "the_distance_already_exists": "Diese Entfernung existiert bereits",
  "distance_deleted_successfully": "Entfernung erfolgreich gelöscht",
  "update_shipping": "Versand aktualisieren",
  "tobeconfirmed": "Zu bestätigen",
  "km": "km",
  "time": "Zeit",
  "coin": "€",
  "currency_config": "eur",
  "ddi": "49",
  "date_format": "dd.MM.yyyy",
  "date_format_v2": "dd.MM",
  "order_updated_at": "Aktualisiert am",
  "welcome": "Willkommen",
  "description": "Beschreibung",
  "orders": "Bestellungen",
  "order": "Bestellung",
  "order_management": "Bestellverwaltung",
  "new_feature": "Neue Funktion",
  "work_waiters_taking": "Arbeiten Sie mit Kellnern, die Bestellungen aufnehmen?",
  "register_you_waiters_quickly": "Dann registrieren Sie Ihre Kellner und geben Sie schnell Bestellungen auf.",
  "dont_work_waiters": "Ich arbeite nicht mit Kellnern",
  "register_waiters": "Meine Kellner registrieren",
  "orders_were_not_received": "Bestellungen, die nicht empfangen wurden.",
  "orders_appointments": "Bestellungen/Termine",
  "efficiency": "Effizienz",
  "incredible_agility": "Unglaubliche Agilität bei der Verwaltung von Tischen und Bestellungen wie nie zuvor; dieses System ist alles, wovon Sie immer geträumt haben, um mehr Geld zu verdienen und Ihr Restaurant zu organisieren.",
  "automation": "Automatisierung",
  "now_you_control": "Jetzt kontrollieren Sie die Tische und Bestellungen in Ihrem Restaurant automatisch, ohne Fehler oder zusätzliche Arbeit, um die Bestellungen aufzunehmen.",
  "qrcode_self_service": "QR-Code-Selbstbedienungstechnologie am Tisch; kein Kellner erforderlich, um Bestellungen aufzunehmen.",
  "self_service": "Selbstbedienung",
  "customers_place_orders_themselves": "Mit dieser Selbstbedienung geben Ihre Kunden ihre Bestellungen selbst am Tisch auf, und die Bestellungen werden automatisch direkt in Ihrer Küche in der Reihenfolge gedruckt, in der sie eingegangen sind.",
  "zero_waste": "Null Verschwendung",
  "indecipherable_handwriting": "Verabschieden Sie sich von unleserlicher Handschrift, Fehlern und Verlusten bei der Speisenzubereitung. Halten Sie alles in Ihrem Restaurant reibungslos und effizient am Laufen.",
  "closure": "Abschluss",
  "automatically_separates_calculates": "Schnelle Rechnungsabwicklung direkt am Tisch oder an der Kasse. WhatsMenu trennt und berechnet automatisch, was jede Bestellung verbraucht hat, sodass Sie Kunden einzeln belasten können, wenn sie den Tisch verlassen, bevor er geschlossen wird, und sorgt für reibungslose und fehlerfreie Transaktionen.",
  "ordering_system": "Das Bestellsystem",
  "allows_your_customer": "Ermöglicht Ihrem Kunden, Tag und Uhrzeit für den Empfang seiner Bestellung zu wählen.",
  "allows_customer_they_wish": "Ermöglicht dem Kunden, Tag und Uhrzeit zu wählen, an dem er die Bestellung erhalten möchte.",
  "you_can_sell_24h": "Sie können rund um die Uhr verkaufen, auch wenn Ihr Geschäft geschlossen ist.",
  "prevents_setbacks": "Verhindert Rückschläge, wie z.B. dass der Kunde nicht erreichbar ist und der Lieferant umsonst fährt.",
  "advantages": "Vorteile",
  "configure_days_establishment": "Konfigurieren Sie die vom Geschäft akzeptierten Tage und Zeiten.",
  "customer_best_time_for_them": "Der Kunde wählt die beste Zeit für sich.",
  "helps_improve": "Hilft bei der Verbesserung der Organisation der Lieferlogistik.",
  "speak_with_consultant": "Sprechen Sie jetzt mit einem Berater",
  "must_be_between": "Der Wert muss zwischen 0,49 und 0,99 liegen",
  "acess": "Zugriff",
  "delete_addresses": "Adressen löschen",
  "addresses_deleted": "Adressen erfolgreich gelöscht!",
  "control_of": "Kontrolle von",
  "error_deleting_addresses": "Fehler beim Löschen der Adressen. Überprüfen Sie die Konsole für weitere Details.",
  "user": "Benutzer",
  "sucess_updated": "erfolgreich aktualisiert",
  "something_wrong": "Etwas ist schief gelaufen",
  "talk_it_team": "Sprechen Sie mit dem IT-Team",
  "user_profile": "Benutzerprofil",
  "profile": "Profil",
  "not_registered": "Nicht registriert",
  "with_area_code": "Mit Vorwahl",
  "owner_cell_phone": "Handynummer des Inhabers",
  "owner_email_address": "E-Mail-Adresse des Inhabers",
  "full_name": "Vollständiger Name",
  "register_customer": "Kunde registrieren",
  "select_payment_gateway_for_user": "Wählen Sie das Zahlungsgateway für den Benutzer aus, bevor Sie fortfahren.",
  "whatsapp": "Telefonnummer",
  "internationalization": "Internationalisierung",
  "asaas_account_disconnected": "Asaas-Konto vom Profil getrennt",
  "unable_disconnect_asaas_account": "Asaas-Konto konnte nicht vom Profil getrennt werden.",
  "add_ons": "Zusätze",
  "there_no_services_generate": "Es gibt keine Dienste zu generieren",
  "boleto_generated": "Rechnung erfolgreich generiert",
  "issue_add_ons": "Zusätze ausstellen",
  "make_sure_boleto_generated": "Stellen Sie sicher, dass eine Rechnung für diese Rechnung generiert wurde",
  "invoice_settlement": "Rechnungsbegleichung",
  "reset_security_key": "Sicherheitsschlüssel zurücksetzen",
  "assign_support": "Support zuweisen",
  "acessing_user_account": "Zugriff auf Benutzerkonto",
  "logging_in": "Anmeldung...",
  "back_to_list": "Zurück zur Liste",
  "menu": "Menü",
  "client_contracted_menu_registration": "Kunde hat Menüregistrierung beauftragt",
  "printer": "Drucker",
  "client_purchased_printer": "Der Kunde hat einen Drucker gekauft",
  "user_data": "Benutzerdaten",
  "salesperson": "Verkäufer",
  "responsible_support": "Verantwortlicher Support",
  "name": "Name",
  "no_name": "Kein Name",
  "no_email": "Keine E-Mail",
  "invalid_email": "Ungültige E-Mail",
  "ssn_ein": "Steuer-ID/USt-IdNr.",
  "no_ssn_ein": "Keine Steuer-ID/USt-IdNr.",
  "invalid": "Ungültig",
  "no_whatsapp": "Keine Telefonnummer",
  "registration_date": "Registrierungsdatum",
  "no_date": "Kein Datum",
  "login_attempts": "Anmeldeversuche",
  "due_date": "Fälligkeitsdatum",
  "payment_method": "Zahlungsmethode",
  "card": "Karte",
  "password": "Passwort",
  "your_password": "Ihr Passwort",
  "passwords": "Passwörter",
  "enter_new_password": "Neues Passwort eingeben",
  "security_key": "Sicherheitsschlüssel",
  "reset": "Zurücksetzen",
  "access_panel": "Panel zugreifen",
  "not_have_permission_adm": "Sie haben keine Berechtigung, auf ein Administratorkonto zuzugreifen",
  "clear_addresses": "Adressen löschen",
  "clear": "Löschen",
  "delete_addresses_customer": "Möchten Sie alle Adressen oder nur die außerhalb des Liefergebiets löschen?",
  "outside_area": "Außerhalb des Liefergebiets",
  "no": "Nein",
  "yes": "Ja",
  "user_cancellation": "Benutzerkündigung",
  "cancel_charges_user": "Gebühren für diesen Benutzer stornieren?",
  "version_next": "Version *Next*",
  "test": "Test",
  "activate": "Aktivieren",
  "automatic_printing_browser": "Automatisches Drucken über den Browser",
  "observations": "Bemerkungen",
  "save": "Speichern",
  "title": "Titel",
  "block_profile": "Profil sperren",
  "value_whatsapp": "Wert auf Telefonnummer",
  "enable_shipping_mi": "Umschaltung zwischen Stadtteilen und Kilometern aktivieren",
  "double_sending_whatsapp": "Doppelsendung auf Telefonnummer",
  "enable_pix_online": "Online-Pix aktivieren",
  "enable_online_card": "Online-Karte aktivieren",
  "remove_type_street": "Straßentyp entfernen?",
  "old_pix": "Alter Pix",
  "negotiation_fee": "Verhandlungsgebühr",
  "days": "Tage",
  "expires_in": "Läuft ab in",
  "expired_since": "Abgelaufen seit",
  "disconnect_account": "Asaas-Konto trennen",
  "unlink": "Verknüpfung aufheben",
  "account_asaas": "Asaas-Konto",
  "unlink_asaas_account": "Möchten Sie das Asaas-Konto von diesem Kunden trennen",
  "quantity": "Menge",
  "issue": "Ausstellen",
  "number_installments": "Anzahl der Raten",
  "invoices": "Rechnungen",
  "transaction_id": "Transaktions-ID",
  "value": "Wert",
  "total_order": "Gesamtbestellung",
  "action": "Aktion",
  "action_remove_user_the": "Diese Aktion wird den Benutzer aus dem",
  "notice": "Hinweis",
  "settlement": "Begleichung",
  "warning_financial_password": "ACHTUNG! Sie müssen ein Finanzpasswort einrichten.",
  "warning_v2": "Gehen Sie dazu im Menü zur Option Einstellungen.",
  "passwords_or": "Passwörter oder",
  "click_here": "Hier klicken",
  "enter_financial_password": "Geben Sie Ihr Finanzpasswort ein",
  "confirm": "Bestätigen",
  "forgot_financial_password": "Finanzpasswort vergessen",
  "recover_password": "Passwort wiederherstellen",
  "check_inbox_spam": "Überprüfen Sie Ihren 'Posteingang' oder 'Spam'-Ordner.",
  "message_subject": "Die Nachricht mit dem Betreff",
  "password_recovery": "Passwortwiederherstellung",
  "whastmenu": "Whatsmenu",
  "start_date": "Startdatum",
  "end_date": "Enddatum",
  "search": "Suchen",
  "print": "Drucken",
  "report": "Bericht",
  "product": "Produkt",
  "product_code": "Produktcode",
  "no_product_code": "Kein Produktcode",
  "product_code_abbreviation": "Prod. Code",
  "product_code_already_exists": "Es gibt bereits ein Produkt mit diesem Code.",
  "pizza_product_code_already_exists": "Speichern nicht möglich: Ein Produkt oder eine Pizzagröße verwendet diesen Code bereits.",
  "products": "Produkte",
  "product_m": "Produkt",
  "qty_sold": "Verkaufte Menge",
  "total_amount": "Gesamtbetrag",
  "cash_summary": "KASSENÜBERSICHT",
  "qty": "Menge",
  "incomes": "Einnahmen",
  "table_closing": "Tischabschluss",
  "table": "Tisch",
  "counter": "Theke",
  "request": "Anfrage",
  "cancelled": "Storniert",
  "cancelled_up": "STORNIERT",
  "cancelled_o": "Storniert",
  "outflows": "Abflüsse",
  "phone_footer": "Telefon",
  "phone_abbreviation": "Tel.",
  "n_orders": "Anz. Bestellungen",
  "language": "Sprache",
  "select_language": "Sprache auswählen",
  "client": "Kunde",
  "currency": "Währung",
  "brazil": "Brasilien (R$)",
  "united_states": "USA ($)",
  "united_kingdom": "Großbritannien (£)",
  "portugal": "Portugal (€)",
  "ireland": "Irland (€)",
  "jamaica": "Jamaika (J$)",
  "paraguay": "Paraguay (₲)",
  "mexico": "Mexiko (MX$)",
  "dubai": "Dubai (د.إ)",
  "germany": "Deutschland (€)",
  "country": "Land",
  "select_currency": "Währung auswählen",
  "portuguese_brazil": "Portugiesisch (Brasilien)",
  "portuguese_portugal": "Portugiesisch (Portugal)",
  "spanish_paraguay": "Spanisch (Paraguay)",
  "english_us": "Englisch (USA)",
  "english_uk": "Englisch (Großbritannien)",
  "english_ie": "Englisch (Irland)",
  "english_jamaica": "Englisch (Jamaika)",
  "spanish_mexico": "Spanisch (Mexiko)",
  "english_grenada": "Englisch (Grenada)",
  "english_ar": "Englisch (Dubai)",
  "english_ireland": "Englisch (Irland)",
  "german_de": "Deutsch (Deutschland)",
  "average_ticket": "Durchschnittlicher Bon",
  "total_spent": "Gesamtausgaben",
  "total_orders": "Gesamtbestellungen",
  "total_amount_spent": "Gesamtausgegebener Betrag",
  "customer_report": "Kundenbericht",
  "number_of_orders": "Anz. Bestellungen",
  "order_history": "Bestellhistorie",
  "order_code": "Bestellcode",
  "change_for": "Wechselgeld für",
  "change": "Wechselgeld",
  "payment": "Zahlung",
  "payment_abbreviation": "Zahlst.",
  "all_customers": "Alle Kunden",
  "filter": "Filtern",
  "order_volume": "Bestellvolumen",
  "amount_consumed": "Verbrauchter Betrag",
  "no_results_found": "Keine Ergebnisse gefunden",
  "no_customer_found": "Kein Kunde mit diesem Namen gefunden",
  "phone_number": "Telefonnummer",
  "customer_found": "Gefundene Kunden",
  "opening_time_must_closing": "Die Öffnungszeit muss nach der Schließzeit liegen!",
  "time_will_not_take": "Diese Zeit wird nicht wirksam am",
  "following": "Folgenden",
  "day": "Tag",
  "changing_existing_time": "Erwägen Sie, eine bestehende Zeit zu ändern am",
  "mentioned": "Erwähnten",
  "please_select_day": "Bitte wählen Sie einen Tag!",
  "please_set_valid_time": "Bitte setzen Sie eine gültige Zeit!",
  "operating_hours": "Öffnungszeiten",
  "the_change_were": "Die Änderungen wurden nicht vorgenommen, da ungültige Zeiten vorhanden sind. Bitte korrigieren Sie die hervorgehobenen Felder und versuchen Sie es erneut.",
  "product_availability": "Produktverfügbarkeit",
  "setting_operating_hours": "Öffnungszeiten einrichten",
  "choose_days_times": "WÄHLEN SIE DIE TAGE UND ZEITEN",
  "select_all": "Alle auswählen",
  "from": "Von",
  "until": "Bis",
  "add": "Hinzufügen",
  "open": "Öffnen",
  "close": "Schließen",
  "actions": "Aktionen",
  "invalid_time": "Ungültige Zeit",
  "if_work_overnight": "Wenn Sie auch nachts arbeiten, also nach Mitternacht, registrieren Sie die Stunden so",
  "pause": "Pausieren",
  "unpause": "Fortsetzen",
  "delete": "Löschen",
  "type": "Typ",
  "priority": "Priorität",
  "email_server": "E-Mail-Server",
  "content": "Inhalt",
  "destination": "Ziel",
  "address": "Adresse",
  "discount": "Rabatt",
  "surchage": "Zuschlag",
  "fixed": "Fest",
  "percentage": "Prozent",
  "type_of_fee": "Art der Gebühr",
  "type_of_value": "Art des Wertes",
  "fee_amount": "Gebührenbetrag",
  "copy": "KOPIEREN",
  "successfully_duplicated": "erfolgreich dupliziert",
  "not_possible_duplicate": "Die Kategorie konnte nicht dupliziert werden",
  "unable_duplicate_product": "Das Produkt konnte nicht dupliziert werden.",
  "category": "Kategorie",
  "successfully": "erfolgreich",
  "the_category": "die Kategorie",
  "could_not": "Konnte nicht",
  "paused": "Pausiert",
  "unpaused": "Fortgesetzt",
  "the_product": "das Produkt",
  "sizes": "Größen",
  "size": "Größe",
  "edges_doughs": "Ränder und Teige",
  "flavors": "Geschmacksrichtungen",
  "menu_information": "Menüinformationen",
  "cat_standard": "Kat. Standard",
  "qty_product": "Anz. Produkte",
  "qty_add_ons": "Anz. Zusätze",
  "qty_size": "Anz. Größen",
  "qty_edges_doughs": "Anz. Ränder/Teige",
  "qty_flavors": "Anz. Geschmacksrichtungen",
  "you_edited": "Sie haben bearbeitet",
  "items": "Artikel",
  "cancel_edit": "Möchten Sie die Bearbeitung abbrechen",
  "there_are_no": "Es gibt keine",
  "to_update": "zu aktualisieren",
  "disconnect_account_asaas": "Asaas-Konto trennen",
  "package": "Pakete",
  "appointments": "Termine",
  "appointment": "Termin",
  "share_facebook": "Auf Facebook teilen",
  "copy_clipboard": "In Zwischenablage kopieren",
  "copied": "Kopiert",
  "link_sucess_copied": "Link erfolgreich kopiert.",
  "unlink_link_copied": "Link konnte nicht kopiert werden, Ihr Browser unterstützt diese Funktion nicht.",
  "message_menu_adjust_prices": "Das Menü ist Ihr Produktschaufenster auf WhatsMenu. Hier können Sie Kategorien erstellen, Artikel, Extras und Optionen hinzufügen, Verfügbarkeit festlegen und Preise anpassen.",
  "add_category": "Kategorie hinzufügen",
  "reorder_menu": "Menü neu ordnen",
  "search_g": "Suchen",
  "search_place": "Suchen...",
  "complements": "Ergänzungen",
  "complement": "Ergänzung",
  "required_complement_all_items_paused": "Speichern nicht möglich: Bei „{{name}}\" sind alle Elemente pausiert, die Ergänzung ist aber erforderlich. Aktivieren Sie mindestens ein Element oder deaktivieren Sie „Pflicht-Ergänzung\".",
  "pizza_flavors": "Pizza-Geschmacksrichtungen",
  "duplicate": "Duplizieren",
  "edit": "Bearbeiten",
  "stock": "Lagerbestand",
  "low": "Niedrig",
  "out_stock": "Nicht vorrätig",
  "edit_cover": "Cover bearbeiten",
  "add_size": "Größe hinzufügen",
  "add_item": "Artikel hinzufügen",
  "add_complements": "Ergänzung hinzufügen",
  "edit_flavors": "Geschmacksrichtungen bearbeiten",
  "cancel_edits": "Bearbeitung abbrechen",
  "prices": "Preise",
  "price": "Preis",
  "photo": "Foto",
  "discard_changes": "Änderungen verwerfen",
  "enter_valid_value": "Bitte geben Sie einen gültigen Wert ein!",
  "in_stock": "AUF LAGER",
  "add_flavors_firt_pizza": "Um Geschmacksrichtungen hinzuzufügen, erstellen Sie zuerst eine Pizzagröße.",
  "add_flavors": "Geschmacksrichtungen hinzufügen",
  "updated_now": "Jetzt aktualisiert",
  "flavors_will_be": "Geschmacksrichtungen werden",
  "flavor_will_be": "Geschmacksrichtung wird",
  "please_wait": "Bitte warten...",
  "coin_t": "Münze",
  "please_wait_n": "Bitte warten",
  "edit_products": "Produkte bearbeiten",
  "products_will_be": "Produkte werden",
  "product_will_be": "Produkt wird",
  "no_results_your_search": "Keine Ergebnisse für Ihre Suche",
  "no_category_registred": "Keine Kategorie registriert",
  "add_items_bulk": "Artikel in großen Mengen hinzufügen",
  "you_changing_promotional_price": "Sie ändern den Aktionspreis des Produkts.",
  "system": "System",
  "cash_detail": "Kassendetails",
  "operator": "Bediener",
  "image_preview": "Bildvorschau",
  "width": "Breite",
  "height": "Höhe",
  "complete": "Abschließen",
  "review_entered_data": "Bitte überprüfen Sie die eingegebenen Daten.",
  "confirm_financial_password": "Finanzpasswort bestätigen",
  "financial_password": "Finanzpasswort",
  "how_to_make": "So geht's",
  "updated": "aktualisiert",
  "updated_o": "aktualisiert",
  "created": "erstellt",
  "unable_delete_category": "Die Kategorie konnte nicht gelöscht werden",
  "standard": "Standard",
  "delete_category": "Die Kategorie löschen",
  "review_data": "Daten überprüfen",
  "details": "Details",
  "availability": "Verfügbarkeit",
  "select_category_model": "Kategoriemodell auswählen",
  "acai_ice_creams": "Acai und Eiscreme",
  "burgers": "Burger",
  "meal_boxes": "Menüboxen",
  "meal_boxes_size_options": "Menüboxen mit Größenoptionen",
  "build_meal_box": "Eigene Menübox zusammenstellen",
  "butcher_shop": "Metzgerei",
  "produce_section": "Obst und Gemüse",
  "drinks": "Getränke",
  "category_name": "Kategoriename",
  "invalid_category_name": "Ungültiger Kategoriename",
  "characters": "Zeichen",
  "minimum_stock": "Mindestbestand",
  "add_availability_hours": "Verfügbarkeitszeiten hinzufügen",
  "use_addons_another_item": "Zusätze eines anderen Artikels verwenden",
  "creating_addons": "Zusätze erstellen",
  "shared_addons": "Geteilte Zusätze",
  "attention": "Achtung",
  "attention_up": "ACHTUNG",
  "all_changes_addon_affect_other_product": "Alle Änderungen an diesem Zusatz wirken sich auf andere Produkte aus, die ihn verwenden.",
  "link": "Link",
  "attention_addon_linked": "Achtung, dieser Zusatz ist verknüpft mit",
  "attention_addon_linked_v2": "Alle hier vorgenommenen Änderungen wirken sich auf die verknüpften Produkte aus, außer Löschungen.",
  "other": "andere",
  "view_linked_products": "Verknüpfte Produkte anzeigen",
  "invalid_name": "Ungültiger Name",
  "min_greater_max": "Min größer als Maximum",
  "max_less_min": "Max kleiner als Minimum",
  "mandatory_addon": "Pflicht-Zusatz",
  "option": "Option",
  "please_enter_valid_value": "Bitte geben Sie einen gültigen Wert ein",
  "always_available": "Immer verfügbar",
  "enable_stock": "Lagerbestand aktivieren",
  "created_o": "erstellt",
  "create": "Erstellen",
  "was_deleted_successfully": "wurde erfolgreich gelöscht",
  "could_not_delete_flavor": "Die Geschmacksrichtung konnte nicht gelöscht werden",
  "you_really_want_delete": "Möchten Sie wirklich löschen",
  "error": "Fehler",
  "the_flavor": "die Geschmacksrichtung",
  "flavor": "Geschmacksrichtung",
  "image_up_8": "Bild bis 8MB",
  "add_image": "Bild hinzufügen",
  "recomended_resolution_600": "Empfohlene Auflösung von 600x450",
  "please_valid_name": "Bitte geben Sie einen gültigen Namen ein.",
  "message_pause_sales": "Um den Verkauf dieses Artikels zu pausieren, klicken Sie auf die Schaltfläche daneben. Wenn die Schaltfläche aktiviert ist, erscheint der Artikel nicht in Ihrer Speisekarte.",
  "pause_sales": "Verkauf pausieren",
  "resume_sales": "Verkauf fortsetzen",
  "created_successfully": "erfolgreich erstellt.",
  "updated_successfully": "erfolgreich aktualisiert.",
  "was_not_created": "wurde nicht erstellt.",
  "was_not_updated": "wurde nicht aktualisiert.",
  "deleted_successfully": "erfolgreich gelöscht.",
  "could_not_delete": "Konnte nicht löschen.",
  "could_not_pause": "Konnte nicht pausieren",
  "resumed_successfully": "erfolgreich fortgesetzt.",
  "paused_successfully": "erfolgreich pausiert",
  "to_pause_sale_message": "Um den Verkauf dieses Artikels zu pausieren, klicken Sie auf die Schaltfläche daneben. Wenn die Schaltfläche aktiviert ist, erscheint der Artikel nicht in Ihrer Speisekarte.",
  "size_name_already_exists": "Eine Größe mit diesem Namen existiert bereits.",
  "the_size": "die Größe",
  "update": "Aktualisieren",
  "message_delete_remove_another": "Zum Löschen müssen Sie die Geschmacksrichtungen entfernen oder eine andere Pizzagröße hinzufügen",
  "message_really_delete_size": "Möchten Sie die Größe wirklich löschen",
  "message_could_not_delete": "Die Größe konnte nicht gelöscht werden",
  "edit_size": "Größe bearbeiten",
  "cover": "Cover",
  "this_size_accepts": "Diese Größe akzeptiert",
  "add_cover": "Cover hinzufügen",
  "message_cannot_invalid_times": "Änderungen können nicht vorgenommen werden, da ungültige Zeiten vorhanden sind. Bitte korrigieren Sie die hervorgehobenen Felder und versuchen Sie es erneut",
  "review_not_allowed": "Überprüfen Sie Ihre Zusätze; leere Namen sind nicht erlaubt",
  "could_not_delete_product": "Das Produkt konnte nicht gelöscht werden",
  "delete_the_product": "Das Produkt löschen",
  "promotion": "Aktion",
  "activate_promotion": "Aktion aktivieren",
  "button_enable_disable_promotion": "Verwenden Sie die Schaltfläche daneben, um die Aktion zu aktivieren oder zu deaktivieren.",
  "original_price": "Originalpreis",
  "promotional_price": "Aktionspreis",
  "promotion_ends_in": "Endet in",
  "available_for": "Verfügbar für",
  "message_products_not_created": "Die Produkte wurden nicht erstellt, da ungültige Zeiten vorhanden sind. Bitte korrigieren Sie die hervorgehobenen Felder und versuchen Sie es erneut",
  "products_created_successfully": "Alle Produkte wurden erfolgreich erstellt.",
  "products_not_created": "Produkte wurden nicht erstellt.",
  "create_products_bulk": "Produkte in großen Mengen erstellen",
  "shortcuts": "Tastenkürzel",
  "right_arrow": "Pfeil rechts",
  "left_arrow": "Pfeil links",
  "next_step": "Nächster Schritt",
  "back_one_step": "Einen Schritt zurück",
  "create_products": "Produkte erstellen",
  "add_product": "Produkt hinzufügen",
  "duplicate_product": "Produkt duplizieren",
  "product_name": "Produktname",
  "table_price": "Tischpreis",
  "product_description": "Produktbeschreibung",
  "duplicate_r": "Duplizieren",
  "no_product_added": "Kein Produkt hinzugefügt",
  "creating_products": "Produkte werden erstellt...",
  "reordered_successfully": "Erfolgreich neu geordnet",
  "could_not_reorder_items": "Die Artikel konnten nicht neu geordnet werden",
  "message_press_and_hold": "Halten Sie 1 Sekunde gedrückt und ziehen Sie dann die Artikel an die gewünschte Position. Diese Reihenfolge wird auch in Ihrem Geschäft widergespiegelt.",
  "reordegring_wait": "Neu ordnen, bitte warten...",
  "you_any_categories_yet": "Sie haben noch keine Kategorien registriert.",
  "please_review_data": "Bitte überprüfen Sie die Daten.",
  "review": "Überprüfen",
  "fee_shipping": "Kostenloser Versand",
  "fee_shipping_up": "KOSTENLOSER VERSAND",
  "fee": "Gebühr",
  "disc": "Rab.",
  "free": "Kostenlos",
  "be_determined": "Zu bestimmen",
  "disabled": "Deaktiviert",
  "order_slip": "Bestellzettel",
  "order_slips": "Bestellzettel",
  "ssn": "Steuer-ID",
  "duration": "Dauer",
  "delivery_date": "Lieferdatum",
  "paid_up": "BEZAHLT",
  "coupon_used": "Verwendeter Gutschein",
  "delivery": "Lieferung",
  "coupon": "Gutschein",
  "payment_in": "Zahlung mit",
  "total_paid": "Gesamt bezahlt",
  "checkout": "Kasse",
  "paid_online_up": "ONLINE BEZAHLT",
  "delivery_person": "Lieferant",
  "s_n": "J/N",
  "technology": "Technologie",
  "missing": "Fehlend",
  "waiter": "Kellner",
  "paid": "Bezahlt",
  "delivery_fee": "Liefergebühr",
  "printing_error": "Druckfehler",
  "could_not_send_printing": "Die Kopie konnte nicht zum Drucken gesendet werden.",
  "order_confirmation": "Bestellbestätigung",
  "could_not_print_order": "Der Druck der Bestellung konnte nicht bestätigt werden",
  "change_date": "Datum ändern",
  "pending_prints": "Ausstehende Drucke",
  "message_pending_print": "ausstehende Druckaufträge. Möchten Sie diese Bestellungen drucken?",
  "there_are": "Es gibt",
  "print_all": "Alle drucken",
  "could_not_play_sound": "Der Ton konnte nicht abgespielt werden.",
  "printing_up": "DRUCKEN",
  "cancel_order": "Bestellung stornieren",
  "reinstate_order": "Bestellung wiederherstellen",
  "no_orders_print_up": "ES GIBT KEINE BESTELLUNGEN ZUM DRUCKEN",
  "order_preview": "Bestellvorschau",
  "teste_print_order": "Testdruck Bestellung",
  "report_request": "Berichtsanfrage",
  "received": "Erhalten",
  "preparation": "Zubereitung",
  "delivering": "Wird geliefert",
  "served": "Serviert",
  "ready_for_pickup": "Abholbereit",
  "speak_customer": "Mit Kunden sprechen",
  "select": "Auswählen",
  "add_address": "Adresse hinzufügen",
  "edit_address": "Adresse bearbeiten",
  "filling_establishment_address": "Ausfüllen der Geschäftsadresse",
  "zip_code": "PLZ",
  "invalid_zip_code": "Ungültige PLZ",
  "number": "Nummer",
  "neighborhood": "Stadtteil",
  "city": "Stadt",
  "complete_address": "Vollständige Adresse",
  "confirm_location": "Standort bestätigen",
  "confirm_and_fill_address": "Bestätigen Sie Ihre Adresse und ergänzen Sie die zusätzlichen Adressangaben.",
  "enter_your_zip_code_for_address": "Geben Sie Ihre Postleitzahl ein, um die Adresse zu finden.",
  "requesting_your_location": "Ihr Standort wird angefordert...",
  "address_found": "Adresse gefunden",
  "confirm_address": "Adresse bestätigen",
  "enter_your_zip_code": "Geben Sie Ihre Postleitzahl ein",
  "i_do_not_know_my_zip_code": "Ich kenne meine Postleitzahl nicht",
  "save_address": "Adresse speichern",
  "choose_saved_address_or_create_new": "Wählen Sie eine gespeicherte Adresse aus oder erstellen Sie eine neue, um mit der Bestellung fortzufahren.",
  "use_my_location": "Meinen Standort verwenden",
  "no_saved_address_for_this_client": "Für diesen Kunden sind keine Adressen gespeichert.",
  "select_delivery_location": "Lieferort auswählen",
  "inform_city_and_neighborhood_for_delivery": "Geben Sie die Stadt und den Stadtteil ein, um die Lieferkosten zu berechnen.",
  "searching": "Suche...",
  "complement_address": "Wohnung, Gebäude usw.",
  "delivery_to_your_address": "Lieferung an Ihre Adresse",
  "enter_registed_email_recover_password": "Geben Sie Ihre registrierte E-Mail ein, um Ihr Passwort wiederherzustellen",
  "your_email": "Registrierte E-Mail",
  "please_enter_valid_email": "Bitte geben Sie eine gültige E-Mail ein",
  "email_sent_successfully": "E-Mail erfolgreich gesendet.",
  "send": "Senden",
  "delivery_package": "LIEFERUNG/PAKETE",
  "change_order_date": "Bestelldatum ändern",
  "selected_date": "Ausgewähltes Datum",
  "current_order_date": "Aktuelles Bestelldatum",
  "distribution": "Verteilung",
  "order_coder": "Bestellcode",
  "no_order_selected": "Keine Bestellung ausgewählt",
  "go_back": "Zurück",
  "pickup": "Abholung",
  "deliver": "Liefern",
  "no_items_this_date": "Keine Artikel für dieses Datum",
  "all": "Alle",
  "pending": "Ausstehend",
  "marked_received": "Als erhalten markiert",
  "local_delivery": "Lokale Lieferung",
  "summary_of": "Zusammenfassung von",
  "your": "Ihr",
  "your_a": "Ihre",
  "filter_use": "Verwendeter Filter",
  "choose_date_summary": "Wählen Sie ein Datum für die Zusammenfassung",
  "printing": "Drucken",
  "selected_orders": "Ausgewählte Bestellungen",
  "regarding": "Bezüglich",
  "calendar_view": "Kalenderansicht",
  "loading_orders": "Bestellungen werden geladen...",
  "order_slip_fees": "Bestellzettelgebühren",
  "fees": "Gebühren",
  "charge": "Belasten",
  "next_confirm": "Weiter/Bestätigen",
  "back_cancel": "Zurück/Abbrechen",
  "proceed": "Fortfahren",
  "delivery_report": "Lieferbericht",
  "qty_of_deliveries": "Lieferungen",
  "total_delivery_fees": "Gebühren",
  "delivery_report_r": "Lieferbericht",
  "code_order": "Bestellcode",
  "date": "Datum",
  "discard": "Verwerfen",
  "pending_changes": "Ausstehende Änderungen",
  "you_whant_save_them": "Es gibt nicht gespeicherte Änderungen. Möchten Sie sie speichern?",
  "new": "Neu",
  "my_profile": "Mein Profil",
  "delivery_drivers": "Lieferfahrer",
  "tables": "Tische",
  "no_active_waiter": "Kein aktiver Kellner",
  "message_register_waitr_enable": "Um einen Kellner zu registrieren oder einen bestehenden zu aktivieren, gehen Sie zu Einstellungen > Tisch > im Tab Kellner, oder klicken Sie auf",
  "register_waiter": "Kellner registrieren",
  "coupons": "Gutscheine",
  "social_media": "Soziale Medien",
  "reports": "Berichte",
  "financial_report": "Finanzbericht",
  "daily_orders": "Tägliche Bestellungen",
  "motoboys_daily": "Tägliche Motoboys",
  "deliveries_statement": "Lieferschein",
  "delivery_driver_signature": "Unterschrift des Lieferfahrers",
  "enter_daily_amount": "Täglichen Betrag eingeben",
  "monthly_orders": "Monatliche Bestellungen",
  "cash_register_closing": "Kassenabschluss",
  "best_sellers": "Bestseller",
  "customer_report_side": "Kundenbericht",
  "general": "Allgemein",
  "cash_registers": "Kassen",
  "domains": "Domains",
  "payment_methods": "Zahlungsmethoden",
  "administrator": "Administrator",
  "support_bonus": "Support-Bonus",
  "salesperson_report": "Verkäuferbericht",
  "annual_report": "Jahresbericht",
  "updates": "Updates",
  "exit": "Beenden",
  "support_hours": "Montag bis Samstag",
  "settings": "Einstellungen",
  "phone": "Telefon",
  "press": "Drücken",
  "order_already_printed": "Bestellung wurde bereits gedruckt",
  "order_not_printed": "Bestellung nicht gedruckt",
  "wait_order_printed": "Bitte warten Sie, bis die Bestellung gedruckt ist.",
  "displaying": "Anzeigen",
  "of": "von",
  "filter_o": "Filtern",
  "caption": "Beschriftung",
  "order_list": "Bestellliste",
  "message_download_whatsmenu_desktop": "Laden Sie jetzt den NEUEN WhatsMenu Desktop herunter",
  "message_less_work": "Weniger Arbeit und mehr Umsatz",
  "message_virtual_assistant": "Virtueller Assistent für Telefonnummer",
  "message_loyalty_program": "Treueprogramm",
  "message_first_purchase": "Erstkauf-Gutschein",
  "message_automated_sales_bot": "Automatisierter Verkaufsbot",
  "message_status_updates": "Statusaktualisierungen ohne Tabs zu öffnen",
  "message_download_app": "App herunterladen",
  "donwload_the_whatsmenu": "WhatsMenu Desktop herunterladen",
  "message_download_whatsmenu_printers": "Laden Sie jetzt den neuen WhatsMenu Printers herunter",
  "message_automatic_printing_mobile": "Automatisches Drucken auf dem Handy",
  "message_printing_multiple_printers": "Drucken auf mehreren Druckern",
  "message_copy_printing": "Kopierdruck",
  "message_download_gplay": "Über Google Play herunterladen",
  "message_downlaod_whatsmenu_printers": "WhatsMenu Printers herunterladen",
  "message_audio_disabled": "Audio deaktiviert. Bitte interagieren Sie mit dem Bildschirm, um es zu aktivieren.",
  "message_monthly_invoice_available": "Monatliche Rechnung zur Zahlung verfügbar! Hier klicken.",
  "message_menu_locked": "Ihr Menü könnte gesperrt sein, weil Ihr Abonnement überfällig ist! Hier klicken.",
  "monday": "Montag",
  "tuesday": "Dienstag",
  "wednesday": "Mittwoch",
  "thursday": "Donnerstag",
  "friday": "Freitag",
  "saturday": "Samstag",
  "sunday": "Sonntag",
  "january": "Januar",
  "february": "Februar",
  "march": "März",
  "april": "April",
  "may": "Mai",
  "june": "Juni",
  "july": "Juli",
  "august": "August",
  "september": "September",
  "october": "Oktober",
  "november": "November",
  "december": "Dezember",
  "search_for": "Suche nach",
  "summary": "Zusammenfassung",
  "detailed_summary": "Detaillierte Zusammenfassung",
  "number_orders": "Anzahl der Bestellungen",
  "no_fees": "Keine Gebühren",
  "no_deliverys": "Keine Lieferungen",
  "deliverys": "Lieferungen",
  "number_deliveries": "Anzahl der Lieferungen",
  "products_total": "Alle Produkte hinzugefügen",
  "tax_delivery_total": "Gesamte Liefersteuern für den Zeitraum",
  "total_sales_and_coupons": "Gesamtumsatz für den Zeitraum - Gesamte Gutscheine (ohne Berücksichtigung von Zahlungsgebühren/Rabatten)",
  "total_canceled": "Gesamt storniert",
  "number_canceled_orders": "Anzahl der stornierten Bestellungen",
  "total_fees": "Gesamte Gebühren",
  "no_fees_period": "Keine Gebühren für diesen Zeitraum",
  "no_orders_period": "Keine Bestellungen in diesem Zeitraum",
  "no_deliveries_period": "Keine Lieferungen in diesem Zeitraum",
  "payment_methods_n": "Zahlungsmethoden",
  "waitstaff": "Kellner",
  "creation_date": "Erstellungsdatum",
  "daily_report": "Täglicher Bericht",
  "monthly_report": "Monatlicher Bericht",
  "delivery_registration": "Lieferant Registrierung",
  "error_deleting_delivery_person": "Fehler beim Löschen des Lieferanten",
  "error_pausing_activating": "Fehler beim Pausieren/Aktivieren des Lieferanten",
  "error_editing_delivery_person": "Fehler beim Bearbeiten des Lieferanten",
  "delivery_person_name": "Name des Lieferanten",
  "enter_delivery_person": "Geben Sie den Namen des Lieferanten ein",
  "enter_whatsapp_number": "Geben Sie die WhatsApp-Nummer ein",
  "registered_delivery": "Registrierte Lieferanten",
  "fill_all_fields": "Bitte füllen Sie alle Felder aus.",
  "coupon_management": "Gutschein-Management",
  "coupon_code": "Gutschein-Code",
  "coupon_already_exists": "Dieser Gutschein existiert bereits",
  "offer_type": "Angebotstyp",
  "coupon_type": "Gutscheintyp",
  "first_purchase": "Erster Kauf",
  "minimum_amount": "Minimum Betrag",
  "code": "Code",
  "unable_create_the_coupon": "Der Gutschein konnte nicht erstellt werden.",
  "coupon_not_created": "Der Gutschein wurde nicht erstellt.",
  "status_coupon": "Gutscheinstatus",
  "actives": "Aktiv",
  "for_orders": "für Bestellungen",
  "inactive": "Inaktiv",
  "successfully_deleted": "Erfolgreich gelöscht",
  "delete_coupon": "Gutschein löschen",
  "business_offer_deliveries": "Bieten Sie Lieferungen an?",
  "customer_pick_up_order_onsite": "Der Kunde kann die Bestellung vor Ort abholen",
  "cash_register": "Kasse",
  "active_cash_management": "Aktive Kassenverwaltung",
  "message_currently_open_cash": "Sie haben derzeit offene Kassen. Bitte schließen Sie diese ab.",
  "before_register_management": "Bevor Sie die Kassenverwaltung registrieren, müssen Sie die aktuelle Kasse schließen.",
  "customers": "Kunden",
  "display_date_birth": "Geburtsdatum anzeigen",
  "require_date_birth": "Geburtsdatum erforderlich",
  "default_texts": "Standardtexte",
  "changing_default_text_observations": "Standardtext für Beobachtungen ändern",
  "product_note": "Produktnote",
  "example_no_mayonnaise": "z. B. Keine Mayo, kein Salat, etc.",
  "pizza_note": "Pizzanote",
  "leave_any_note_product_here": "Lassen Sie hier eine Notiz zum Produkt.",
  "message_client": "Hallo [NOME], wie geht es Ihnen?",
  "status_received": "Status erhalten",
  "you_order_production": "Yay [NOME], Ihre Bestellung ist in Produktion!",
  "status_delivering": "Status Lieferung",
  "yay_order_already_way": "Yay [NOME], Ihre Bestellung ist bereits unterwegs!",
  "status_pickup": "Status Abholung",
  "order_ready_pickup": "Yay, [NOME], Ihre Bestellung ist zur Abholung bereit!",
  "order_status_pos": "Status der Bestellung",
  "order_successfully_placed": "[NOME], Ihre Bestellung wurde erfolgreich aufgegeben. Verfolgen Sie den Bestellstatus unten!",
  "greeting_message": "Begrüßungsnachricht",
  "message_hello": "Hallo, [NOME]!",
  "welcome_to": "Willkommen bei",
  "check_menu_order": "Schauen Sie sich unser Menü an, um Ihre Bestellung aufzugeben",
  "exclusive_offers": "Exklusive Angebote für Bestellungen über den Link",
  "team": "Team",
  "use_a_printer": "Verwenden Sie einen Drucker",
  "group_order_printing": "Bestellartikel zum Drucken gruppieren",
  "group_command_printing": "Artikel der Bestellung am Tisch zum Drucken gruppieren",
  "print_test": "Drucktest",
  "test_print": "Testdruck",
  "printer_driver": "Druckertreiber",
  "printing_app": "Druck-App",
  "print_width": "Druckbreite",
  "letters": "Buchstaben",
  "small": "Klein",
  "large": "Groß",
  "copies": "Kopien",
  "necessary_whatsmenu_android_installed": "Es ist notwendig, die Whatsmenu Printer 2.0 App installiert zu haben (nur Android).",
  "pizza_options": "Pizza-Optionen",
  "assign_price_most_expensive": "Den Preis des teuersten Gerichts zuweisen",
  "different_crusts_each_flavor": "Erlaube unterschiedliche Teigböden für jeden Belag",
  "allow_each_flavor": "Erlaube Beläge für jeden Geschmack",
  "stock_options": "Lageroptionen",
  "display_out_of_stock_product_addons": "'Ausverkauft'-Status für pausierte Produkte und Add-ons anzeigen?",
  "hide_ssn_receipt": "SSN-Option auf dem Beleg ausblenden",
  "description_top_product_page": "Produktfoto und Beschreibung oben auf der Produktseite anzeigen",
  "activate_catalog_mode_delivery": "Katalogmodus für Lieferung aktivieren",
  "activate_catalog_the_table": "Katalogmodus am Tisch aktivieren",
  "automations": "Automatisierungen",
  "ignore_products_and_categories_availability": "Verfügbarkeit von Produkten und Kategorien ignorieren",
  "send_status_page_pos_customer": "Möchten Sie dem Kunden die Statusseite am POS senden?",
  "only_indentification": "Nur die Identifikation",
  "label": "Bezeichnung",
  "saving": "Speichern...",
  "are_no_pending_changes": "Es gibt keine ausstehenden Änderungen",
  "no_changes": "Keine Änderungen",
  "saved": "Gespeichert",
  "saved_successfully": "Erfolgreich gespeichert.",
  "order_date": "Bestelldatum",
  "tomorrow": "Morgen",
  "today": "Heute",
  "deliver_pickup": "Lieferung/Abholung",
  "delivery_e": "Lieferung",
  "closed_o": "Geschlossen",
  "receive_orders_from": "Bestellungen empfangen von",
  "enable_options_the_settings_for": "Aktivieren Sie die Optionen in den Einstellungen für",
  "printed": "Gedruckt",
  "are_no_orders_moment": "Es gibt momentan keine Bestellungen",
  "hours": "Stunden",
  "review_delivery_hours": "Bitte überprüfen Sie die Lieferzeiten.",
  "changes_saved": "Änderungen erfolgreich gespeichert.",
  "not_saved": "Nicht gespeichert",
  "unable_save_check_connection": "Speichern nicht möglich, bitte prüfen Sie Ihre Verbindung.",
  "no_changes_to_save": "Es gibt keine Änderungen zum Speichern.",
  "delivery_type_activated": "Mindestens eine Lieferart muss aktiviert sein",
  "pickups": "Abholungen",
  "deliveries_pickups": "Lieferungen/Abholungen",
  "delivery_types_must_one_activated": "Lieferarten müssen mindestens eine aktivierte Option haben",
  "activate_orders": "Bestellungen aktivieren",
  "delivery_scheduling": "Lieferplanung",
  "order_settings": "Bestelleinstellungen",
  "pickup_onsite": "Abholung vor Ort",
  "allow_onesite_pickups": "Abholung vor Ort erlauben",
  "allow_delivery_services": "Lieferservices erlauben",
  "make_available": "Verfügbar machen",
  "starting_from": "beginnt ab",
  "allow": "Erlauben",
  "for_day": "für den Tag",
  "within": "innerhalb",
  "group": "Gruppe",
  "every": "jede",
  "minutes": "Minuten",
  "max_of": "Maximal",
  "per_day_from": "pro Tag von 1 bis 1000",
  "per_hour": "pro Stunde",
  "display_menu_as": "Im Menü anzeigen als",
  "minimum_for_delivery": "Mindestbestellwert für Lieferung",
  "minimum_for_pickup": "Mindestbestellwert für Abholung",
  "register_order_cash_register": "Bestellungen an der Kasse registrieren",
  "on_day_ordered": "Am Tag der Bestellung",
  "on_delivery_day": "Am Liefertag",
  "availability_of": "Verfügbarkeit von",
  "dates_not_be_available": "Daten, an denen Sie nicht verfügbar sind",
  "select_special_dates": "Wählen Sie die speziellen Daten aus, an denen Sie nicht verfügbar sind",
  "select_a_date": "Wählen Sie ein Datum",
  "defined_dates": "Definierte Daten",
  "remove": "Entfernen",
  "values": "Werte",
  "minimum_order_for_pickup": "Mindestbestellwert für Abholung",
  "table_name_already_exists": "Ein Tisch mit diesem Namen existiert bereits",
  "create_table": "Tisch erstellen",
  "enter_valid_name": "Bitte geben Sie einen gültigen Namen ein",
  "new_table": "Neuer Tisch",
  "creating_table": "Tisch wird erstellt",
  "using_table_system": "Tischsystem verwenden",
  "time_zone_successfully_changed": "Zeitzone erfolgreich geändert",
  "table_name": "Tischname",
  "cancel": "Abbrechen",
  "available": "Verfügbar",
  "occupied": "Belegt",
  "paused_a": "Pausiert",
  "selected": "Ausgewählt",
  "you_haven_registered_tables": "Sie haben noch keine Tische registriert",
  "how_close_entire_table": "Wie man den gesamten Tisch schließt",
  "how_close_individual": "Wie man einzelne Rechnungen schließt",
  "table_settings": "Tisch-Einstellungen",
  "fee_name_already_exists": "Eine Gebühr mit diesem Namen existiert bereits.",
  "fee_name_cannot_empty": "Der Gebührenname darf nicht leer sein.",
  "enter_value_greater_than": "Geben Sie einen Wert größer als",
  "add_fee": "Gebühr hinzufügen",
  "created_successfully_a": "erfolgreich erstellt",
  "activate_fee": "Gebühr aktivieren",
  "automatic_charge": "Automatische Gebühr",
  "changed_successfully": "erfolgreich geändert",
  "delete_fee": "Gebühr löschen",
  "deleted_successfuly": "Erfolgreich gelöscht",
  "register_waitstaff": "Servicepersonal registrieren",
  "update_waitstaff": "Servicepersonal aktualisieren",
  "create_waitstaff": "Servicepersonal erstellen",
  "edit_waitstaff": "Servicepersonal bearbeiten",
  "delete_waitstaff": "Servicepersonal löschen",
  "deleted_successfully_o": "Erfolgreich gelöscht",
  "restrict_menu": "Menü einschränken",
  "unable_retrieve_menu_information": "Menüinformationen können derzeit nicht abgerufen werden, bitte versuchen Sie es erneut",
  "creating_fees": "Gebühren werden erstellt",
  "fee_name": "Gebührenname",
  "fee_already_exists": "Diese Gebühr existiert bereits",
  "type_charge": "Art der Gebühr",
  "enter_number_greater_than": "Geben Sie eine Zahl größer als",
  "charge_automatically": "Automatisch berechnen",
  "deactive": "Deaktivieren",
  "registering_waitstaff": "Servicepersonal wird registriert",
  "placing_order_waiter": "Bestellung als Kellner aufnehmen",
  "placing_pizza_order_waiter": "Pizza-Bestellung als Kellner aufnehmen",
  "waitstaff_name": "Name des Servicepersonals",
  "permission": "Berechtigung",
  "manager": "Manager",
  "allow_orders": "Bestellungen erlauben",
  "register": "Registrieren",
  "categories": "Kategorien",
  "select_categories_waiter_permitted": "Wählen Sie die Kategorien aus, aus denen der Kellner bestellen darf",
  "call_waitstaff": "Servicepersonal rufen",
  "keep_waitstaff_logged": "Servicepersonal angemeldet lassen",
  "change_password": "Passwort ändern",
  "change_table": "Tisch wechseln",
  "enter_valid_name_different_current": "Bitte geben Sie einen gültigen Namen oder einen anderen Namen als den aktuellen ein",
  "delete_table": "Tisch löschen",
  "activated_a": "aktiviert",
  "pause_table": "Tisch pausieren",
  "not_possible_pause_table_open": "Es ist nicht möglich, einen Tisch mit offenen Rechnungen zu pausieren",
  "table_options_up": "TISCHOPTIONEN",
  "points": "Punkte",
  "settings_up": "EINSTELLUNGEN",
  "background": "Hintergrund",
  "resources": "Ressourcen",
  "register_cashier": "Kassierer registrieren",
  "registering_operator": "Operator wird registriert",
  "placing_order_operator": "Bestellung als Operator aufnehmen",
  "operator_name": "Operatorname",
  "operators": "Operatoren",
  "box_settings": "Kasseneinstellungen",
  "delete_operator": "Operator löschen",
  "edit_operator": "Operator bearbeiten",
  "create_operator": "Operator erstellen",
  "update_operator": "Operator aktualisieren",
  "register_operator": "Operator registrieren",
  "there_failure_transaction": "Bei der Transaktion ist ein Fehler aufgetreten",
  "change_card": "Karte wechseln",
  "unable_change_payment_card": "Zahlungskarte konnte nicht geändert werden.",
  "redirecting_payment_page": "Weiterleitung zur Zahlungsseite.",
  "difficulty_generating_payment_screen": "Wir haben Probleme bei der Erstellung des Zahlungsbildschirms. Bitte versuchen Sie es erneut.",
  "payment_gateway": "Zahlungsanbieter",
  "no_payment_gateway_found": "Kein Zahlungsanbieter gefunden",
  "subscription": "Abonnement",
  "adding_your_subscription": "Wir fügen Ihr Abonnement hinzu.",
  "failure_adding_your_subscription": "Fehler beim Hinzufügen Ihres Abonnements",
  "subscription_created_successfully": "Ihr Abonnement wurde erfolgreich erstellt",
  "failure_processing_try_again": "Es gab einen Fehler bei der Verarbeitung. Bitte versuchen Sie es erneut",
  "ongoing_monthly_invoice": "Es liegt eine laufende Monatsrechnung vor.",
  "subscription_canceled": "Ihr Abonnement wurde gekündigt",
  "required": "Erforderlich",
  "additional": "Zusätzlich",
  "monthly": "Monatlich",
  "annual": "Jährlich",
  "semiannual": "Halbjährlich",
  "monthly_payment": "Monatliche Zahlung per Karte",
  "add_registration_service": "Registrierungsdienst hinzufügen",
  "with_printer": "Mit Drucker",
  "email": "E-Mail",
  "showLocale": true,
  "secret_number": "Steuer-ID",
  "enter_motoboys_secret_number": "Geben Sie die Steuer-ID des Lieferfahrers ein",
  "cpf_cnpj_on_the_receipt": "Steuer-ID auf dem Beleg",
  "cpf_invalid": "Ungültige Steuer-ID",
  "invalid_cpf": "Ungültige Steuer-ID",
  "check_code": "Vorwahl überprüfen",
  "last_name": "Nachname",
  "enter_your_last_name": "Geben Sie Ihren Nachnamen ein",
  "switzerland": "Schweiz (CHF)",
  "denmark": "Dänemark (kr)",
  "finland": "Finnland (€)",
  "france": "Frankreich (€)",
  "grenada": "Grenada (EC$)",
  "italy": "Italien (€)",
  "norway": "Norwegen (kr)",
  "spain": "Spanien (€)",
  "sweden": "Schweden (kr)",
  "now_accepting_scheduled_orders": "Jetzt werden geplante Bestellungen akzeptiert",
  "DE": "Deutschland",
  "AF": "Afghanistan",
  "AL": "Albanien",
  "DZ": "Algerien",
  "AD": "Andorra",
  "AO": "Angola",
  "AR": "Argentinien",
  "AM": "Armenien",
  "AU": "Australien",
  "AT": "Österreich",
  "AZ": "Aserbaidschan",
  "BS": "Bahamas",
  "BH": "Bahrain",
  "BD": "Bangladesch",
  "BB": "Barbados",
  "BY": "Belarus",
  "BE": "Belgien",
  "BZ": "Belize",
  "BJ": "Benin",
  "BT": "Bhutan",
  "BO": "Bolivien",
  "BA": "Bosnien und Herzegowina",
  "BW": "Botswana",
  "BR": "Brasilien",
  "BN": "Brunei",
  "BG": "Bulgarien",
  "KH": "Kambodscha",
  "CM": "Kamerun",
  "CA": "Kanada",
  "CL": "Chile",
  "CN": "China",
  "CO": "Kolumbien",
  "CR": "Costa Rica",
  "HR": "Kroatien",
  "CU": "Kuba",
  "CY": "Zypern",
  "CZ": "Tschechien",
  "DK": "Dänemark",
  "EC": "Ecuador",
  "EG": "Ägypten",
  "EE": "Estland",
  "ET": "Äthiopien",
  "FI": "Finnland",
  "FR": "Frankreich",
  "GE": "Georgien",
  "GH": "Ghana",
  "GR": "Griechenland",
  "GT": "Guatemala",
  "HN": "Honduras",
  "HK": "Hongkong",
  "HU": "Ungarn",
  "IS": "Island",
  "IN": "Indien",
  "ID": "Indonesien",
  "IR": "Iran",
  "IQ": "Irak",
  "IE": "Irland",
  "IL": "Israel",
  "IT": "Italien",
  "JM": "Jamaika",
  "JP": "Japan",
  "JO": "Jordanien",
  "KZ": "Kasachstan",
  "KE": "Kenia",
  "KR": "Südkorea",
  "KW": "Kuwait",
  "LV": "Lettland",
  "LB": "Libanon",
  "LY": "Libyen",
  "LT": "Litauen",
  "LU": "Luxemburg",
  "MY": "Malaysia",
  "MT": "Malta",
  "MX": "Mexiko",
  "MA": "Marokko",
  "NL": "Niederlande",
  "NZ": "Neuseeland",
  "NG": "Nigeria",
  "NO": "Norwegen",
  "PK": "Pakistan",
  "PA": "Panama",
  "PY": "Paraguay",
  "PE": "Peru",
  "PH": "Philippinen",
  "PL": "Polen",
  "PT": "Portugal",
  "QA": "Katar",
  "RO": "Rumänien",
  "RU": "Russland",
  "SA": "Saudi-Arabien",
  "RS": "Serbien",
  "SG": "Singapur",
  "SK": "Slowakei",
  "SI": "Slowenien",
  "ZA": "Südafrika",
  "ES": "Spanien",
  "SE": "Schweden",
  "CH": "Schweiz",
  "TW": "Taiwan",
  "TH": "Thailand",
  "TR": "Türkei",
  "UA": "Ukraine",
  "AE": "Vereinigte Arabische Emirate",
  "GB": "Vereinigtes Königreich",
  "US": "Vereinigte Staaten",
  "UY": "Uruguay",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "highlight_products": "Hervorgehobene Produkte",
  "highlight_description": "Entdecken Sie unsere beliebtesten Produkte!",
  "highlights": "Highlights",
  "highlight_successfuly_updated": "Highlight erfolgreich aktualisiert!",
  "highlight_category": "Kategorie hervorgehobener Produkte",
  "highlight_explanation": "Mit einem Stern markierte Produkte werden in Ihrem WhatsMenu-Shop hervorgehoben!",
  "complete_category": "Vollständige Kategorie",
  "stripe": "Stripe",
  "stripe_invalid_api_key": "Geben Sie einen gültigen API-Schlüssel ein.",
  "stripe_test_key_not_allowed": "Testschlüssel sind nicht zulässig. Bitte verwenden Sie einen Produktionsschlüssel (sk_live_).",
  "stripe_integration_saved_successfully": "Stripe-Integration erfolgreich gespeichert.",
  "stripe_integration_save_error": "Die Integration konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
  "stripe_logo_alt": "Stripe-Logo",
  "online_payment_automatic": "Online-Zahlung - Automatisch",
  "stripe_international_payments": "Internationale Zahlungen",
  "stripe_international_payments_description": "Akzeptieren Sie internationale Karten, Apple Pay und Google Pay mit automatischer Bestellfreigabe.",
  "asaas_logo_alt": "Asaas-Logo",
  "message_avoid_fraud_errors": "Vermeiden Sie Betrug, Fehler und Verzoegerungen, indem Sie Belege nicht manuell in der Banking-App pruefen muessen.",
  "asaas_terms_use": "Nutzungsbedingungen der Asaas Bank",
  "complete_activation_account": "Achtung: Schliessen Sie die Aktivierung Ihres Kontos ab",
  "acess_email": "Greifen Sie auf die E-Mail zu",
  "message_open_asaas_email": "Oeffnen Sie die E-Mail von Asaas und klicken Sie auf den Link, um Ihr Bankpasswort zu erstellen.",
  "message_sent_sms_token": "Wir haben die SMS mit dem Token gesendet an",
  "account_creation_details": "Details zur Kontoerstellung",
  "branch": "Filiale",
  "account_label": "Konto",
  "acess_asaas_account": "Greifen Sie auf Ihr Asaas-Konto zu",
  "termis_of_use": "Nutzungsbedingungen",
  "webhooks": "Webhooks",
  "webhook": "Webhook",
  "preparationTime": "Vorbereitungszeit",
  "unable_fetch_webhook_status": "Webhook-Status konnten nicht geladen werden",
  "webhook_updated_successfully": "Webhook erfolgreich aktualisiert",
  "unable_update_webhook_status": "Webhook-Status konnten nicht aktualisiert werden",
  "confirm_change": "Aenderung bestaetigen",
  "webhook_confirm_message": "Moechten Sie den Webhook <b>{{name}}</b> {{action}}?",
  "stripe_description_1": "Stripe ist eine globale Finanzinfrastruktur-Plattform, mit der Restaurants jeder Größe weltweit Online-Zahlungen akzeptieren können.",
  "stripe_description_2": "Erstellen Sie ein Konto und akzeptieren Sie Zahlungen in mehreren Währungen – ohne Verträge oder Bankdaten.",
  "stripe_international_currencies": "Internationale Währungen",
  "stripe_currency_flag_alt": "Flagge {{code}}",
  "stripe_connect_account": "Mein Stripe-Konto verbinden",
  "stripe_api_key_label": "Stripe API-Schlüssel",
  "stripe_api_key_placeholder": "sk_live_...",
  "stripe_currency_cad": "Kanadischer Dollar",
  "stripe_currency_eur": "Euro",
  "stripe_currency_mxn": "Mexikanischer Peso",
  "stripe_currency_aud": "Australischer Dollar",
  "stripe_currency_gbp": "Pfund Sterling",
  "stripe_currency_nzd": "Neuseeländischer Dollar",
  "stripe_currency_cnh": "Chinesischer Renminbi",
  "stripe_currency_jpy": "Japanischer Yen",
  "stripe_currency_usd": "US-Dollar",
  "stripe_currency_chf": "Schweizer Franken",
  "stripe_currency_sek": "Schwedische Krone",
  "stripe_currency_hkd": "Hongkong-Dollar",
  "stripe_currency_try": "Türkische Lira",
  "stripe_currency_krw": "Südkoreanischer Won",
  "stripe_digital_wallets_title": "Google Pay & Apple Pay",
  "stripe_digital_wallets_description": "Stripe unterstützt auch Zahlungen über Google Pay und Apple Pay und bietet Ihren Kunden ein schnelles und sicheres Bezahlerlebnis.",
  "stripe_fees_title": "Stripe-Gebührenübertragung",
  "stripe_fees_description": "Konfigurieren Sie zusätzliche Gebühren, die automatisch erhoben werden, wenn der Kunde über Stripe bezahlt.",
  "stripe_fees_enable": "Stripe-Gebühren erheben",
  "stripe_fees_enable_description": "Wenn aktiviert, werden die konfigurierten Gebühren dem Gesamtbetrag der Bestellung beim Stripe-Checkout hinzugefügt.",
  "stripe_fees_fixed_label": "Feste Gebühr",
  "stripe_fees_fixed_placeholder": "0.00",
  "stripe_fees_percentage_label": "Prozentuale Gebühr (%)",
  "stripe_fees_percentage_placeholder": "0.00",
  "stripe_fee": "Stripe-Gebühr",
  "fees_settings": "Gebühreneinstellungen",
  "dashboard_auto_assign": "Automatischer Gutschein",
  "congrats_auto_assign": "🎉 HERZLICHEN GLÜCKWUNSCH! Du hast",
  "auto_assign_discount": "Rabatt erhalten!",
  "store_auto_assign_1": "Füge",
  "store_auto_assign_2": "mehr hinzu, um zu erhalten",
  "price_from": "Vorher:",
  "price_to": "Jetzt:",
  "progressive_discount": "Progressive Rabatte",
  "progressive_discounts": "Progressive Rabatte",
  "progressive_discount_manager": "Verwaltung progressiver Rabatte",
  "discounts": "Rabatte",
  "discount_status": "Rabattstatus",
  "delete_discount": "Rabatt löschen",
  "delete_discount_confirm": "Sind Sie sicher, dass Sie den Rabatt löschen möchten?",
  "discount_not_created": "Rabatt nicht erstellt",
  "discount_not_created_desc": "Der Rabatt konnte nicht erstellt werden",
  "discount_name": "Name des Rabatts",
  "discount_already_exists": "Rabatt existiert bereits",
  "discount_invalid_chars": "Sonderzeichen sind nicht erlaubt",
  "discount_allowed_chars_hint": "Nur Buchstaben, Zahlen, Bindestrich (-) und Unterstrich (_)",
  "coupon_invalid_chars": "Sonderzeichen sind nicht erlaubt",
  "coupon_allowed_chars_hint": "Nur Buchstaben, Zahlen, Bindestrich (-) und Unterstrich (_)",
  "coupon_code_valid": "Code verfügbar",
  "discount_code_valid": "Name verfügbar",
  "applied_discount": "Rabatt angewendet",
  "invalid_coupon": "Der Gutschein ist ungültig!",
  "select_your_discount": "Wählen Sie Ihren Rabatt",
  "cashback_why_better": "Warum Cashback traditionelle Promotionen und Portalanzeigen übertrifft",
  "cashback_money_attractive": "Geld ist attraktiver als Punkte",
  "cashback_defined_validity": "Definierte Gültigkeit",
  "cashback_controlled_cost": "Kontrollierte Kosten",
  "cashback_total_automation": "Vollständige Automatisierung",
  "cashback_rewards_now": "Cashback belohnt das Jetzt. Der Kunde kommt zurück, weil er das Gefühl hat, bereits gewonnen zu haben und das Geld nicht verlieren kann.",
  "cashback_growth_impact": "Wachstum und echte Auswirkungen auf durchschnittliche Ticketgröße und Häufigkeit",
  "cashback_how_to_activate": "SO AKTIVIEREN SIE DIESE FUNKTION:",
  "cashback_set_percentage": "Prozentsatz festlegen",
  "cashback_choose_validity": "Gültigkeit wählen",
  "cashback_activate_save": "Aktivieren und speichern",
  "check_for_updates": "Nach Updates suchen",
  "update_alert": "Update-Benachrichtigung",
  "update_unavailable": "Keine Updates verfügbar.",
  "configure_extra_fees": "Konfigurieren Sie unten zusätzliche Service- oder Weitergabegebühren. Diese Gebühren werden Ihrem Kunden am Ende jeder Bestellung berechnet. Z. B.: Eintrittsgebühr, Parkservice, Kellnerservice, Servicegebühr oder Steuer.",
  "fees_already_exists": "Eine Gebühr mit diesem Namen existiert bereits.",
  "fees_name_cannot_be_empty": "Der Name der Gebühr darf nicht leer sein.",
  "fees_name_too_long": "Der Name der Gebühr darf nicht länger als 20 Zeichen sein.",
  "fees_min_value": "Geben Sie einen Wert größer als {{value}} ein",
  "fees_created": "Gebühr {{code}} erfolgreich erstellt",
  "fees_updated": "{{code}} erfolgreich aktualisiert.",
  "fees_deleted": "Gebühr {{code}} erfolgreich gelöscht",
  "highlight_limit": "Sie können maximal 10 hervorgehobene Produkte haben.",
  "consider_current_value": "Falls ein Wert geändert wurde, wird der aktuelle Wert berücksichtigt",
  "unavailable_products": "Nicht verfügbare Produkte",
  "unavailable_products_desc": "Die folgenden Produkte und/oder deren Ergänzungen sind nicht verfügbar",
  "continue_anyway": "Trotzdem fortfahren",
  "total_clients": "Gesamtkunden",
  "inactive_30d": "Inaktiv seit +30 Tagen",
  "new_clients": "Neukunden",
  "last_order": "Letzte Bestellung",
  "favorite_product": "Lieblingsprodukt",
  "segment": "Segment",
  "inactive_client": "Inaktiv",
  "new_client": "Neu",
  "recurring_client": "Wiederkehrend",
  "loyal_client": "Treuer Kunde",
  "days_ago": "vor {{count}}d",
  "days_without_order": "{{count}}d ohne Bestellung",
  "segments": "Segmente",
  "clear_filters": "Filter zurücksetzen",
  "inactive_days_label": "Kein Auftrag seit (Tagen)",
  "min_ticket_label": "Mind. Ticket",
  "max_ticket_label": "Max. Ticket",
  "client_analysis": "Kundenanalyse",
  "cancellation_rate": "Stornierungsrate",
  "mom_change": "Veränderung M/M",
  "biggest_order": "Größte Bestellung",
  "smallest_order": "Kleinste Bestellung",
  "most_ordered_products": "Meistbestellte Produkte",
  "no_data": "Keine Daten",
  "monthly_frequency": "Monatliche Häufigkeit",
  "trend_up": "↑ wachsend",
  "trend_down": "↓ sinkend",
  "trend_stable": "→ stabil",
  "avg_ticket_by_month": "Ø Ticket pro Monat",
  "preferred_order_days": "Bevorzugte Bestelltage",
  "repurchase_interval": "Wiederholungskaufintervall",
  "average": "Durchschnitt",
  "median": "Median",
  "samples": "Stichproben",
  "requires_at_least_2_orders": "Mindestens 2 Bestellungen erforderlich",
  "export_csv": "CSV exportieren",
  "no_client_found_by_name": "Kein Kunde mit diesem Namen gefunden",
  "based_on_last_orders": "Basierend auf den letzten {{count}} von {{total}} Bestellungen",
  "segment_inactive_15d": "Inaktiv 15d",
  "segment_inactive_30d": "Inaktiv 30d",
  "segment_inactive_60d": "Inaktiv 60d",
  "segment_new_1_order": "Neu (1 Bestellung)",
  "segment_high_ticket": "Hoher Ticket",
  "back_to_list_detail": "← Zurück zur Liste",
  "highlight": "Highlight",
  "trend": "Trend",
  "weighted_average": "Gewichteter Durchschnitt",
  "intervals": "Intervalle",
  "others": "Andere",
  "low_confidence_sample": "⚠ geringe Stichprobe",
  "intervals_in_range": "Intervall(e) in diesem Bereich",
  "ticket_label": "Ticket",
  "total_label": "Gesamt",
  "no_orders_this_month": "Keine Bestellungen diesen Monat",
  "block_date": "Sperrdatum",
  "payment_date": "Zahlungsdatum",
  "cmv_report_title": "CMV-Bericht",
  "cmv_health_score": "Gesundheits-Score",
  "cmv_alert_critical": "Produkte mit kritischem CMV!",
  "cmv_alert_critical_desc": "Produkte mit einem CMV über 35 % beeinträchtigen die Rentabilität.",
  "cmv_alert_potential_savings": "Mögliches Einsparpotenzial pro Einheit:",
  "cmv_alert_priority_products": "Priorisierte Produkte zur Überprüfung:",
  "cmv_coverage_title": "Kostenabdeckung:",
  "cmv_coverage_desc": "Produkte ohne erfasste Kosten. Erfassen Sie die Kosten für eine vollständige Analyse und präzise Entscheidungen.",
  "cmv_success_title": "Ausgezeichnet! Ihre Preisgestaltung ist gesund",
  "cmv_success_desc": "Keine Produkte mit kritischem CMV. Weiterhin regelmäßig überwachen.",
  "cmv_avg": "Durchschnittlicher CMV",
  "cmv_very_high": "Sehr hoher CMV",
  "cmv_ideal": "Idealer CMV",
  "cmv_very_low": "Sehr niedrig",
  "cmv_no_cost": "Ohne Kosten",
  "cmv_urgent_action": "Dringende Maßnahme",
  "cmv_perfect": "Perfekt",
  "cmv_register_costs": "Kosten erfassen",
  "cmv_see_products": "Produkte anzeigen",
  "cmv_search_product": "Produkt suchen",
  "cmv_search_placeholder": "Name oder Kategorie...",
  "cmv_category": "Kategorie",
  "cmv_all_categories": "Alle",
  "cmv_type": "Typ",
  "cmv_delivery": "Lieferung",
  "cmv_table": "Tisch",
  "cmv_status": "CMV-Status",
  "cmv_all_status": "Alle",
  "cmv_export_excel": "Excel exportieren",
  "cmv_showing": "Angezeigt",
  "cmv_of": "von",
  "cmv_products": "Produkte",
  "cmv_with_costs": "mit erfassten Kosten",
  "cmv_how_to_interpret": "So interpretieren Sie den CMV:",
  "cmv_very_high_desc": "Kosten zu hoch. Lieferanten neu verhandeln oder Preis anpassen.",
  "cmv_ideal_desc": "Gesunder Rentabilitätsbereich.",
  "cmv_very_low_desc": "Hohe Marge. Promotionsstrategien erwägen.",
  "cmv_updated_at": "Aktualisiert am:",
  "cmv_loading": "CMV-Analyse wird geladen...",
  "cmv_product": "Produkt",
  "cmv_sale_price": "Verkaufspreis",
  "cmv_cost": "Kosten",
  "cmv_no_products_found": "Keine Produkte mit den angewendeten Filtern gefunden",
  "cmv_no_products_yet": "Noch keine Produkte erfasst",
  "cmv_clear_filters": "Filter zurücksetzen",
  "cmv_disclaimer_1": "Der CMV (Wareneinsatz) umfasst nur direkte Beschaffungs-/Produktionskosten.",
  "cmv_disclaimer_2": "Steuern, Provisionen, Versand, Verpackung und Fixkosten (Miete, Energie) sind in dieser Berechnung nicht enthalten.",
  "cmv_insight_title": "CMV-Analyse",
  "cmv_insight_delivery": "Lieferung",
  "cmv_insight_table": "Tisch",
  "cmv_insight_margin": "Marge",
  "cmv_insight_profit_per_sale": "Gewinn pro Verkauf",
  "cmv_insight_status_critical": "Kritischer CMV!",
  "cmv_insight_status_high": "Hoher CMV",
  "cmv_insight_status_ideal": "Idealer CMV",
  "cmv_insight_status_low": "Sehr niedriger CMV",
  "cmv_insight_suggestion_critical": "Lieferanten neu verhandeln oder Preis erhöhen",
  "cmv_insight_suggestion_high": "Kosten oder Verkaufspreis anpassen",
  "cmv_insight_suggestion_ideal": "Gesunde Marge! Weiter überwachen",
  "cmv_insight_suggestion_low": "Sehr gute Marge! Promotions in Betracht ziehen",
  "cmv_insight_enter_cost": "Kosten eingeben, um die Analyse zu sehen",
  "cmv_insight_enter_price": "Preis eingeben, um die Analyse zu sehen",
  "eat_on_site": "Vor Ort essen",
  "eat_on_local_subtitle": "Verbrauch vor Ort, ohne Versand- und Verpackungskosten",
  "Can_the_customer_eat_here": "Der Kunde kann bestellen, um vor Ort zu essen",
  "cart_type": "Bestellart",
  "eat_here": "Ich werde vor Ort essen",
  "flavor_badge_configure": "Badge konfigurieren",
"flavor_badge_text_label": "Badge-Text",
"flavor_badge_text_placeholder": "Z.B.: Neu, Meistbestellt",
"flavor_badge_color_label": "Badge-Farbe",
"flavor_badge_color_hint": "Hintergrundfarbe wählen",
"flavor_badge_name_fallback": "Geschmacksname",
"flavor_badge_description_fallback": "Ihre Beschreibung hier...",
"flavor_badge_preview_alt": "Vorschau",
"flavor_badge_remove": "Badge entfernen",
"flavor_badge_add": "+ Badge",
  "table_quick_search": "Schnellsuche",
"table_search_placeholder": "Tisch, Nummer oder Kellner",
"table_status_filter_label": "Tischstatus",
"table_filter_all": "Alle",
"table_filter_open": "Geöffnet",
"table_filter_closed": "Geschlossen",
"table_payment_filter_label": "Zahlung",
"filter_all": "Alle",
"payment_status_paid": "Bezahlt",
"payment_status_partial": "Teilweise",
"payment_status_pending": "Ausstehend",
"table_waiter_filter_label": "Kellner",
"table_open_badge": "Geöffnet",
"table_closed_badge": "Geschlossen",
"table_orders_pending_tooltip": "{{count}} Bestellung(en) ausstehend",
"table_order_singular": "Bestellung",
"table_order_plural": "Bestellungen",
"table_orders_cancelled": "storniert",
"table_open_duration": "seit {{hours}}h{{minutes}}min geöffnet",
"table_closed_duration": "war {{hours}}h{{minutes}}min geöffnet",
"table_no_time": "keine Uhrzeit",
"table_waiter_name_label": "Kellner:",
"payment_cleared": "Zahlung abgeschlossen",
"payment_partial_label": "Teilzahlung",
"payment_pending_label": "Zahlung ausstehend",
"table_total_value_label": "Gesamt:",
"nfe_emitted_tooltip": "NFC-e wurde ausgestellt",
"nfe_emit_tooltip": "NFC-e ausstellen",
"nfe_no_eligible_orders": "Keine berechtigten Bestellungen für die Ausstellung",
"nfe_close_table_first": "Schließen Sie den Tisch, um NFC-e auszustellen",
"nfe_emitted_alt": "NFC-e für Tisch ausgestellt",
"nfe_emit_table_alt": "NFC-e für Tisch ausstellen",
"nfe_blocked_alt": "NFC-e gesperrt",
"table_paid_label": "Bezahlt:",
"table_due_label": "Offen:",
"table_fixed_fee_label": "Festgebühr:",
"table_percentage_fee_label": "Prozentuale Gebühr:",
"table_print_col": "Druck",
"table_order_code_col": "Bestellcode",
"table_name_col": "Name",
"table_total_col": "Gesamt",
"table_time_col": "Uhrzeit",
"table_status_col": "Status",
"table_served_status": "Serviert",
"table_fees_footer": "Gebühren: +{{fixed}} / +{{percentage}}%",
"table_total_footer_label": "Tischgesamt:",
"table_no_results": "Keine Tische für die angewendeten Filter gefunden.",
"table_name_fallback": "Tisch #{{id}}",
"table_payment_not_informed": "Nicht angegeben",
"delivery_person_signed_successfully": "Fahrer erfolgreich unterschrieben",
"icon_category": "Kategoriensymbol",
"icon_category_optional": "Kategoriensymbol (optional)",
"sounds_notification": "Order notification sound",
"play_sound_delivery": "Enable delivery sound",
"play_sound_eat_on_site": "Enable eat on site order sound",
"play_sound_table": "Enable table order sound",
"play_sound_package": "Enable scheduling sound",
"edit_order": "Bestellung bearbeiten",
"editing_ongoing": "Bearbeitung läuft",
"cancelled_parentheses": "(STORNIERT)",
"news": "Neues",
"cashback_message": "Du hast einen Umsatz von R$ {{cartTotalCashback}} erzielt, der durch R$ {{cartTotalCashbackValue}} Cashback unterstützt wurde.",
"group_fees": "Gebühren gruppieren",
"technical_support": "Technischer Support",
"everyday": "Montag bis Sonntag"
}
